const GLOSSARY_CONTEXT = {
  'INST-VISION': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Vision',
        shortDefinition: "Représentation de l'avenir souhaité qui donne une direction durable à 2SG.",
        detailedDefinition: "Description ambitieuse et relativement stable de ce que 2SG cherche à devenir ou à rendre possible à long terme. Elle oriente la stratégie et les arbitrages sans se confondre avec une liste d'actions, un calendrier ou un objectif ponctuel."
      },
      DE: {
        term: 'Vision',
        shortDefinition: 'Vorstellung der angestrebten Zukunft, die 2SG eine dauerhafte Richtung gibt.',
        detailedDefinition: 'Ambitionierte und relativ stabile Beschreibung dessen, was 2SG langfristig werden oder ermöglichen möchte. Sie richtet Strategie und Abwägungen aus, ohne mit einer Maßnahmenliste, einem Zeitplan oder einem einzelnen Ziel verwechselt zu werden.'
      },
      EN: {
        term: 'Vision',
        shortDefinition: 'A view of the desired future that gives 2SG a lasting direction.',
        detailedDefinition: 'An ambitious and relatively stable description of what 2SG seeks to become or make possible in the long term. It guides strategy and trade-offs without being confused with an action list, schedule or short-term objective.'
      }
    }
  },
  'INST-MISSION': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Mission',
        shortDefinition: 'Rôle durable que 2SG se donne pour transformer sa vision en utilité concrète.',
        detailedDefinition: "Énoncé de ce que 2SG fait, pour quels bénéficiaires, membres, clients ou partenaires et par quels grands moyens. La mission relie l'identité de l'institution à son action quotidienne sans détailler toutes les activités."
      },
      DE: {
        term: 'Mission',
        shortDefinition: 'Dauerhafter Auftrag, mit dem 2SG seine Vision in konkreten Nutzen überführt.',
        detailedDefinition: 'Aussage darüber, was 2SG für welche Begünstigten, Mitglieder, Kundinnen und Kunden oder Partner tut und mit welchen übergeordneten Mitteln. Die Mission verbindet die Identität der Institution mit ihrem täglichen Handeln, ohne jede Aktivität einzeln aufzulisten.'
      },
      EN: {
        term: 'Mission',
        shortDefinition: 'The lasting role through which 2SG turns its vision into concrete value.',
        detailedDefinition: 'A statement of what 2SG does, for which beneficiaries, members, customers or partners, and through which broad means. The mission connects institutional identity with day-to-day action without detailing every activity.'
      }
    }
  },
  'INST-BUT': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'But institutionnel',
        shortDefinition: 'Finalité institutionnelle générale que 2SG poursuit à travers sa mission.',
        detailedDefinition: "Finalité globale qui précise la contribution recherchée par 2SG. Elle donne un cap commun aux objectifs et aux projets, mais reste plus large qu'un résultat mesurable, une action ou une tâche."
      },
      DE: {
        term: 'Institutioneller Zweck',
        shortDefinition: 'Übergeordneter institutioneller Zweck, den 2SG durch seine Mission verfolgt.',
        detailedDefinition: 'Übergeordneter Zweck, der den von 2SG angestrebten Beitrag beschreibt. Er gibt Zielen und Projekten eine gemeinsame Richtung, ist jedoch umfassender als ein messbares Ergebnis, eine Maßnahme oder eine Aufgabe.'
      },
      EN: {
        term: 'Institutional purpose',
        shortDefinition: 'The overarching institutional purpose pursued by 2SG through its mission.',
        detailedDefinition: 'The broad purpose that describes the contribution 2SG seeks to make. It gives common direction to objectives and projects but is broader than a measurable result, action or task.'
      }
    }
  },
  'INST-VALEURS': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Valeurs institutionnelles',
        shortDefinition: 'Principes durables qui orientent les choix, les comportements et les relations de 2SG.',
        detailedDefinition: "Repères partagés servant à apprécier la cohérence des décisions, des pratiques et des partenariats avec l'identité de 2SG. Elles doivent se traduire en comportements observables et ne pas rester de simples déclarations."
      },
      DE: {
        term: 'Institutionelle Werte',
        shortDefinition: 'Dauerhafte Grundsätze, die Entscheidungen, Verhalten und Beziehungen von 2SG leiten.',
        detailedDefinition: 'Gemeinsame Orientierungspunkte zur Beurteilung, ob Entscheidungen, Praktiken und Partnerschaften mit der Identität von 2SG übereinstimmen. Sie müssen sich in beobachtbarem Verhalten zeigen und dürfen nicht bloße Aussagen bleiben.'
      },
      EN: {
        term: 'Institutional values',
        shortDefinition: 'Lasting principles that guide 2SG decisions, behaviours and relationships.',
        detailedDefinition: 'Shared reference points used to assess whether decisions, practices and partnerships are consistent with the identity of 2SG. They must translate into observable behaviours rather than remain declarations only.'
      }
    }
  },
  'GOUV-REGLES-OR': {
    version: 'V5.0',
    translations: {
      FR: {
        term: "Règles d'or de travail",
        shortDefinition: 'Repères pratiques partagés qui traduisent les valeurs de 2SG en comportements de travail.',
        detailedDefinition: "Petit nombre de règles simples servant à guider les décisions et la collaboration, notamment la traçabilité, la documentation utile, la lisibilité de la gouvernance et la proportionnalité des solutions. Elles ne remplacent ni les statuts, ni le règlement intérieur, ni le code de conduite."
      },
      DE: {
        term: 'Goldene Regeln der Zusammenarbeit',
        shortDefinition: 'Gemeinsame praktische Leitlinien, die die Werte von 2SG in die tägliche Zusammenarbeit übertragen.',
        detailedDefinition: 'Eine kleine Zahl einfacher Regeln zur Orientierung von Entscheidungen und Zusammenarbeit, insbesondere zu Nachvollziehbarkeit, nützlicher Dokumentation, verständlicher Governance und verhältnismäßigen Lösungen. Sie ersetzen weder Statuten noch Geschäftsordnung oder Verhaltenskodex.'
      },
      EN: {
        term: 'Golden rules for working together',
        shortDefinition: 'Shared practical guidelines that translate 2SG values into everyday ways of working.',
        detailedDefinition: 'A small set of simple rules guiding decisions and collaboration, particularly traceability, useful documentation, understandable governance and proportionate solutions. They do not replace statutes, internal regulations or a code of conduct.'
      }
    }
  },
  'GOUV-GOUVERNANCE': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Gouvernance',
        shortDefinition: 'Cadre des rôles, décisions, contrôles et responsabilités qui oriente et sécurise 2SG.',
        detailedDefinition: "Ensemble des principes, organes, rôles, droits, délégations, circuits de décision, contrôles et obligations de rendre compte. La gouvernance précise qui propose, décide, valide, exécute et contrôle, sans se réduire à une hiérarchie verticale."
      },
      DE: {
        term: 'Governance',
        shortDefinition: 'Rahmen aus Rollen, Entscheidungen, Kontrollen und Verantwortlichkeiten zur Ausrichtung und Absicherung von 2SG.',
        detailedDefinition: 'Gesamtheit von Grundsätzen, Organen, Rollen, Rechten, Delegationen, Entscheidungswegen, Kontrollen und Rechenschaftspflichten. Governance legt fest, wer vorschlägt, entscheidet, freigibt, ausführt und kontrolliert, ohne auf eine vertikale Hierarchie reduziert zu werden.'
      },
      EN: {
        term: 'Governance',
        shortDefinition: 'The framework of roles, decisions, controls and accountabilities that directs and safeguards 2SG.',
        detailedDefinition: 'The set of principles, bodies, roles, rights, delegations, decision paths, controls and reporting duties. Governance clarifies who proposes, decides, approves, executes and controls without being reduced to a vertical hierarchy.'
      }
    }
  },
  'STRAT-STRATEGIE': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Stratégie',
        shortDefinition: 'Ensemble cohérent de choix qui relie la vision de 2SG à des priorités, ressources et résultats.',
        detailedDefinition: "Choix structurants portant sur le positionnement, les priorités, les bénéficiaires ou marchés, les capacités, les partenariats et la séquence de développement. La stratégie indique où concentrer les efforts et à quoi renoncer ; elle ne se confond pas avec le plan d'action qui organise l'exécution."
      },
      DE: {
        term: 'Strategie',
        shortDefinition: 'Zusammenhängende Entscheidungen, die die Vision von 2SG mit Prioritäten, Ressourcen und Ergebnissen verbinden.',
        detailedDefinition: 'Grundlegende Entscheidungen zu Positionierung, Prioritäten, Begünstigten oder Märkten, Fähigkeiten, Partnerschaften und Entwicklungsreihenfolge. Strategie zeigt, worauf Anstrengungen konzentriert und worauf verzichtet wird; sie ist nicht mit dem Maßnahmenplan für die Umsetzung gleichzusetzen.'
      },
      EN: {
        term: 'Strategy',
        shortDefinition: 'A coherent set of choices connecting the 2SG vision to priorities, resources and outcomes.',
        detailedDefinition: 'Structuring choices about positioning, priorities, beneficiaries or markets, capabilities, partnerships and development sequence. Strategy indicates where to focus effort and what not to pursue; it is not the action plan that organises execution.'
      }
    }
  },
  'STRAT-BUSINESS-MODEL': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Business Model',
        shortDefinition: 'Description de la manière dont 2SG crée, délivre et soutient une valeur économique, sociale et organisationnelle.',
        detailedDefinition: "Représentation structurée de la proposition de valeur, des bénéficiaires et clients, des canaux, relations, activités, ressources, partenaires, revenus et coûts. Pour 2SG, il doit aussi rendre visibles l'impact social et la gouvernance responsable. Il explique la logique de fonctionnement, tandis que le Business Plan la chiffre et la planifie."
      },
      DE: {
        term: 'Geschäftsmodell',
        shortDefinition: 'Beschreibung, wie 2SG wirtschaftlichen, sozialen und organisatorischen Wert schafft, vermittelt und erhält.',
        detailedDefinition: 'Strukturierte Darstellung von Wertversprechen, Begünstigten und Kundengruppen, Kanälen, Beziehungen, Aktivitäten, Ressourcen, Partnern, Einnahmen und Kosten. Bei 2SG müssen auch soziale Wirkung und verantwortungsvolle Governance sichtbar sein. Das Geschäftsmodell erklärt die Funktionslogik, während der Businessplan sie quantifiziert und plant.'
      },
      EN: {
        term: 'Business model',
        shortDefinition: 'A description of how 2SG creates, delivers and sustains economic, social and organisational value.',
        detailedDefinition: 'A structured representation of the value proposition, beneficiaries and customers, channels, relationships, activities, resources, partners, revenues and costs. For 2SG, it must also make social impact and responsible governance visible. It explains the operating logic, while the Business Plan quantifies and plans it.'
      }
    }
  },
  'STRAT-BUSINESS-PLAN': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Business Plan',
        shortDefinition: 'Document structuré qui transforme le Business Model et la stratégie en hypothèses, objectifs, moyens et projections.',
        detailedDefinition: "Document versionné présentant le projet, le marché ou besoin, les offres, l'organisation, les opérations, les risques, les investissements, le financement et les projections financières. Il sert à décider, piloter et présenter la trajectoire sur plusieurs années ; ses hypothèses doivent rester traçables et actualisables."
      },
      DE: {
        term: 'Businessplan',
        shortDefinition: 'Strukturiertes Dokument, das Geschäftsmodell und Strategie in Annahmen, Ziele, Mittel und Prognosen überführt.',
        detailedDefinition: 'Versioniertes Dokument mit Projekt, Markt oder Bedarf, Angeboten, Organisation, Betrieb, Risiken, Investitionen, Finanzierung und Finanzprognosen. Es unterstützt Entscheidungen, Steuerung und Darstellung der mehrjährigen Entwicklung; seine Annahmen müssen nachvollziehbar und aktualisierbar bleiben.'
      },
      EN: {
        term: 'Business plan',
        shortDefinition: 'A structured document turning the business model and strategy into assumptions, objectives, resources and projections.',
        detailedDefinition: 'A versioned document covering the project, market or need, offers, organisation, operations, risks, investments, financing and financial projections. It supports decisions, management and presentation of the multi-year trajectory; its assumptions must remain traceable and updateable.'
      }
    }
  },
  'STRAT-BLUEPRINT': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Blueprint institutionnel',
        shortDefinition: "Document vivant qui décrit l'architecture cible et guide la structuration progressive de 2SG.",
        detailedDefinition: "Boussole stratégique et opérationnelle présentant les composantes de l'institution et du Management System, leurs relations, leurs principes et leur évolution visée. Le Blueprint donne une cohérence d'ensemble ; il évolue avec le projet et ne remplace pas les plans détaillés de chaque chantier."
      },
      DE: {
        term: 'Institutioneller Blueprint',
        shortDefinition: 'Lebendes Dokument, das die Zielarchitektur beschreibt und die schrittweise Strukturierung von 2SG leitet.',
        detailedDefinition: 'Strategischer und operativer Orientierungsrahmen für die Bestandteile der Institution und des Managementsystems, ihre Beziehungen, Grundsätze und angestrebte Entwicklung. Der Blueprint schafft Gesamtzusammenhang, entwickelt sich mit dem Projekt weiter und ersetzt nicht die Detailpläne einzelner Vorhaben.'
      },
      EN: {
        term: 'Institutional blueprint',
        shortDefinition: 'A living document describing the target architecture and guiding the progressive structuring of 2SG.',
        detailedDefinition: 'A strategic and operational compass presenting the components of the institution and Management System, their relationships, principles and intended evolution. The blueprint provides overall coherence, evolves with the project and does not replace detailed plans for individual workstreams.'
      }
    }
  },
  'STRAT-FEUILLE-ROUTE': {
    version: 'V5.0',
    translations: {
      FR: {
        term: 'Feuille de route',
        shortDefinition: 'Vue séquencée des étapes, jalons et priorités nécessaires pour progresser vers une cible.',
        detailedDefinition: "Instrument de pilotage qui traduit une stratégie en trajectoire temporelle, avec des étapes, dépendances, jalons, responsables et horizons. Elle coordonne plusieurs projets ou lots sans remplacer leur planification détaillée ni le plan d'action opérationnel."
      },
      DE: {
        term: 'Roadmap',
        shortDefinition: 'Geordnete Übersicht der Schritte, Meilensteine und Prioritäten auf dem Weg zu einem Zielzustand.',
        detailedDefinition: 'Steuerungsinstrument, das eine Strategie in einen zeitlichen Entwicklungspfad mit Etappen, Abhängigkeiten, Meilensteinen, Verantwortlichen und Zeithorizonten übersetzt. Es koordiniert mehrere Projekte oder Lose, ersetzt jedoch weder deren Detailplanung noch den operativen Maßnahmenplan.'
      },
      EN: {
        term: 'Roadmap',
        shortDefinition: 'A sequenced view of the steps, milestones and priorities needed to progress towards a target.',
        detailedDefinition: 'A management instrument translating strategy into a time-based path with stages, dependencies, milestones, owners and horizons. It coordinates several projects or work packages without replacing their detailed planning or operational action plan.'
      }
    }
  },
  'OPS-PLAN-ACTION': {
    version: 'V5.0',
    translations: {
      FR: {
        term: "Plan d'action",
        shortDefinition: 'Organisation concrète des actions, responsables, échéances, ressources et preuves nécessaires à un résultat.',
        detailedDefinition: "Instrument d'exécution dérivé d'une stratégie, d'une feuille de route, d'un projet ou d'une décision. Chaque action doit avoir un responsable, une échéance, un statut, des moyens et une preuve ou un résultat attendu. Il ne doit pas devenir une liste de tâches déconnectée des priorités."
      },
      DE: {
        term: 'Maßnahmenplan',
        shortDefinition: 'Konkrete Organisation der Maßnahmen, Verantwortlichen, Fristen, Ressourcen und Nachweise für ein Ergebnis.',
        detailedDefinition: 'Umsetzungsinstrument, das aus einer Strategie, Roadmap, einem Projekt oder einer Entscheidung abgeleitet wird. Jede Maßnahme benötigt eine verantwortliche Person, eine Frist, einen Status, Mittel sowie einen erwarteten Nachweis oder ein Ergebnis. Der Plan darf nicht zu einer von den Prioritäten losgelösten Aufgabenliste werden.'
      },
      EN: {
        term: 'Action plan',
        shortDefinition: 'The concrete organisation of actions, owners, deadlines, resources and evidence needed to achieve an outcome.',
        detailedDefinition: 'An execution instrument derived from a strategy, roadmap, project or decision. Each action must have an owner, deadline, status, resources and expected evidence or result. It must not become a task list disconnected from priorities.'
      }
    }
  },
  'KM-GED': {
    version: 'V5.2',
    status: 'validated',
    translations: {
      FR: {
        term: 'Gestion électronique des documents (GED)',
        shortDefinition: 'Organisation des documents numériques afin de les classer, retrouver, versionner, sécuriser et conserver.',
        detailedDefinition: "Ensemble coordonné de règles, métadonnées, droits d'accès, statuts, preuves et outils permettant de gérer le cycle de vie des documents de 2SG. La GED facilite la traçabilité et l'accès à la bonne version, mais ne remplace ni la validation métier ni les obligations légales de conservation."
      },
      DE: {
        term: 'Elektronische Dokumentenverwaltung (DMS)',
        shortDefinition: 'Organisation digitaler Dokumente zum Klassifizieren, Auffinden, Versionieren, Schützen und Aufbewahren.',
        detailedDefinition: 'Abgestimmtes System aus Regeln, Metadaten, Zugriffsrechten, Status, Nachweisen und Werkzeugen zur Verwaltung des gesamten Lebenszyklus der 2SG-Dokumente. Die Dokumentenverwaltung verbessert Nachvollziehbarkeit und Zugriff auf die richtige Version, ersetzt jedoch weder die fachliche Freigabe noch gesetzliche Aufbewahrungspflichten.'
      },
      EN: {
        term: 'Electronic document management (EDM)',
        shortDefinition: 'The organisation of digital documents so they can be classified, found, versioned, secured and retained.',
        detailedDefinition: 'A coordinated set of rules, metadata, access rights, statuses, evidence and tools used to manage the lifecycle of 2SG documents. Document management supports traceability and access to the correct version but does not replace business approval or legal retention duties.'
      }
    }
  },
  'KM-KNOWLEDGE-MANAGEMENT': {
    version: 'V5.2',
    status: 'validated',
    translations: {
      FR: {
        term: 'Knowledge Management (KM)',
        shortDefinition: 'Démarche organisée pour identifier, valider, partager et réutiliser les connaissances utiles à 2SG.',
        detailedDefinition: "Processus transversal qui transforme des informations, expériences, décisions, méthodes et retours d'usage en connaissances accessibles et réutilisables. Le Knowledge Management relie les personnes, les pratiques et les sources ; il ne se réduit ni à la veille, ni au stockage de documents, ni à un outil technique."
      },
      DE: {
        term: 'Wissensmanagement (KM)',
        shortDefinition: 'Organisierter Ansatz zum Identifizieren, Validieren, Teilen und Wiederverwenden des für 2SG nützlichen Wissens.',
        detailedDefinition: 'Übergreifender Prozess, der Informationen, Erfahrungen, Entscheidungen, Methoden und Nutzungserkenntnisse in zugängliches und wiederverwendbares Wissen überführt. Wissensmanagement verbindet Menschen, Praktiken und Quellen und ist weder auf Beobachtung noch auf Dokumentenablage oder ein technisches Werkzeug beschränkt.'
      },
      EN: {
        term: 'Knowledge Management (KM)',
        shortDefinition: 'An organised approach to identifying, validating, sharing and reusing knowledge useful to 2SG.',
        detailedDefinition: 'A cross-functional process that turns information, experience, decisions, methods and lessons learned into accessible and reusable knowledge. Knowledge Management connects people, practices and sources; it is not limited to monitoring, document storage or a technical tool.'
      }
    }
  },
  'KM-BASE-CONNAISSANCES': {
    version: 'V5.2',
    status: 'validated',
    translations: {
      FR: {
        term: 'Base de connaissances',
        shortDefinition: 'Ensemble structuré et maintenu de connaissances consultables, sourcées et adaptées aux besoins des utilisateurs.',
        detailedDefinition: "Espace organisé regroupant des fiches, réponses, procédures, définitions, décisions et retours d'expérience dont la provenance et le statut sont visibles. Une base de connaissances privilégie l'usage et la compréhension ; elle se distingue d'un simple dépôt documentaire et du Glossaire, centré sur les termes et leurs définitions."
      },
      DE: {
        term: 'Wissensdatenbank',
        shortDefinition: 'Strukturierter und gepflegter Bestand an nachschlagbarem, belegtem und nutzergerechtem Wissen.',
        detailedDefinition: 'Geordneter Bereich mit Merkblättern, Antworten, Verfahren, Definitionen, Entscheidungen und Erfahrungswerten, deren Herkunft und Status sichtbar sind. Eine Wissensdatenbank ist auf Nutzung und Verständnis ausgerichtet; sie unterscheidet sich von einer reinen Dokumentenablage und vom Glossar, das Begriffe und Definitionen fokussiert.'
      },
      EN: {
        term: 'Knowledge base',
        shortDefinition: 'A structured and maintained collection of searchable, sourced knowledge adapted to user needs.',
        detailedDefinition: 'An organised space containing guidance, answers, procedures, definitions, decisions and lessons learned with visible provenance and status. A knowledge base is designed for use and understanding; it differs from a document repository and from a glossary focused on terms and definitions.'
      }
    }
  },
  'FIN-MONTANT-ENVOYE': {
    version: 'V5.3',
    status: 'validated',
    translations: {
      FR: {
        term: 'Montant envoyé',
        shortDefinition: 'Somme principale confiée au prestataire pour être transférée, hors frais facturés séparément.',
        detailedDefinition: 'Dans un paiement ou transfert 2SG, le montant envoyé désigne le principal destiné au bénéficiaire avant les frais distincts. Il doit être enregistré avec sa devise, sa date, le prestataire et la référence de l’opération. Il ne se confond ni avec le montant total débité au payeur ni avec le montant reçu après conversion.'
      },
      DE: {
        term: 'Gesendeter Betrag',
        shortDefinition: 'Hauptbetrag, der dem Dienstleister zur Überweisung anvertraut wird, ohne separat berechnete Gebühren.',
        detailedDefinition: 'Bei einer 2SG-Zahlung oder -Überweisung bezeichnet der gesendete Betrag den für den Empfänger bestimmten Hauptbetrag vor gesonderten Gebühren. Er wird mit Währung, Datum, Dienstleister und Transaktionsreferenz erfasst. Er ist weder mit dem insgesamt belasteten Betrag noch mit dem nach Umrechnung erhaltenen Betrag gleichzusetzen.'
      },
      EN: {
        term: 'Amount sent',
        shortDefinition: 'Principal amount entrusted to the provider for transfer, excluding separately charged fees.',
        detailedDefinition: 'In a 2SG payment or transfer, the amount sent is the principal intended for the beneficiary before separate fees. It must be recorded with its currency, date, provider and transaction reference. It is distinct from both the total amount debited from the payer and the amount received after conversion.'
      }
    }
  },
  'FIN-FRAIS-TRANSACTION': {
    version: 'V5.3',
    status: 'validated',
    translations: {
      FR: {
        term: 'Frais de transaction',
        shortDefinition: 'Coût facturé par un prestataire pour exécuter un paiement, un transfert ou une conversion.',
        detailedDefinition: 'Les frais de transaction sont enregistrés séparément du montant envoyé afin de rendre visible le coût du service. Leur montant, devise, date, prestataire et justificatif doivent être conservés. Ils peuvent inclure des frais de transfert, de paiement ou d’intermédiation, mais ne doivent pas absorber un écart de change non expliqué.'
      },
      DE: {
        term: 'Transaktionsgebühren',
        shortDefinition: 'Kosten, die ein Dienstleister für die Ausführung einer Zahlung, Überweisung oder Umrechnung berechnet.',
        detailedDefinition: 'Transaktionsgebühren werden getrennt vom gesendeten Betrag erfasst, damit die Dienstleistungskosten sichtbar bleiben. Betrag, Währung, Datum, Dienstleister und Beleg sind zu dokumentieren. Sie können Überweisungs-, Zahlungs- oder Vermittlungsgebühren umfassen, dürfen jedoch keine ungeklärte Wechselkursabweichung verdecken.'
      },
      EN: {
        term: 'Transaction fees',
        shortDefinition: 'Cost charged by a provider to execute a payment, transfer or currency conversion.',
        detailedDefinition: 'Transaction fees are recorded separately from the amount sent so that the service cost remains visible. Their amount, currency, date, provider and supporting evidence must be retained. They may include transfer, payment or intermediary fees, but must not conceal an unexplained foreign-exchange difference.'
      }
    }
  },
  'FIN-MONTANT-TOTAL-DEBITE': {
    version: 'V5.3',
    status: 'validated',
    translations: {
      FR: {
        term: 'Montant total débité',
        shortDefinition: 'Somme totale payée par le donneur d’ordre dans la devise de débit, frais inclus.',
        detailedDefinition: 'Le montant total débité correspond au montant envoyé augmenté des frais facturés dans la même opération. Il décrit la sortie financière réelle du payeur et doit être rapproché du reçu ou du relevé de paiement. Il ne permet pas, à lui seul, de déterminer le montant reçu dans une autre devise.'
      },
      DE: {
        term: 'Gesamtbelastungsbetrag',
        shortDefinition: 'Vom Auftraggeber insgesamt gezahlter Betrag in der Belastungswährung, einschließlich Gebühren.',
        detailedDefinition: 'Der Gesamtbelastungsbetrag entspricht dem gesendeten Betrag zuzüglich der im selben Vorgang berechneten Gebühren. Er bildet den tatsächlichen Mittelabfluss des Zahlers ab und ist mit Quittung oder Zahlungsnachweis abzugleichen. Allein daraus lässt sich der in einer anderen Währung erhaltene Betrag nicht bestimmen.'
      },
      EN: {
        term: 'Total amount debited',
        shortDefinition: 'Total amount paid by the ordering party in the debit currency, including fees.',
        detailedDefinition: 'The total amount debited equals the amount sent plus fees charged in the same transaction. It represents the payer’s actual cash outflow and must be reconciled with the receipt or payment record. On its own, it does not determine the amount received in another currency.'
      }
    }
  },
  'FIN-MONTANT-RECU': {
    version: 'V5.3',
    status: 'validated',
    translations: {
      FR: {
        term: 'Montant reçu',
        shortDefinition: 'Somme effectivement mise à disposition du bénéficiaire dans la devise de destination.',
        detailedDefinition: 'Le montant reçu est enregistré indépendamment du montant envoyé et du total débité. Il doit être confirmé par le prestataire, le bénéficiaire ou un justificatif fiable, avec la devise et la date. Cette séparation permet de contrôler la conversion, les frais et les éventuels écarts.'
      },
      DE: {
        term: 'Erhaltener Betrag',
        shortDefinition: 'Betrag, der dem Empfänger tatsächlich in der Zielwährung zur Verfügung gestellt wird.',
        detailedDefinition: 'Der erhaltene Betrag wird unabhängig vom gesendeten Betrag und vom Gesamtbelastungsbetrag erfasst. Er ist durch den Dienstleister, den Empfänger oder einen verlässlichen Beleg mit Währung und Datum zu bestätigen. Diese Trennung ermöglicht die Kontrolle von Umrechnung, Gebühren und möglichen Abweichungen.'
      },
      EN: {
        term: 'Amount received',
        shortDefinition: 'Amount actually made available to the beneficiary in the destination currency.',
        detailedDefinition: 'The amount received is recorded independently from the amount sent and the total amount debited. It must be confirmed by the provider, the beneficiary or reliable supporting evidence, with its currency and date. This separation supports checks on conversion, fees and any discrepancies.'
      }
    }
  },
  'FIN-TAUX-CHANGE-APPLIQUE': {
    version: 'V5.3',
    status: 'validated',
    translations: {
      FR: {
        term: 'Taux de change appliqué',
        shortDefinition: 'Rapport de conversion effectivement utilisé par le prestataire entre le montant envoyé et le montant reçu.',
        detailedDefinition: 'Le taux de change appliqué est le taux propre à l’opération, calculé ou indiqué par le prestataire, hors frais séparés. Il doit être conservé avec sa date, sa source et les devises concernées. Il se distingue d’un taux de référence ou du taux du jour, qui sert seulement à comparer et expliquer les écarts.'
      },
      DE: {
        term: 'Angewandter Wechselkurs',
        shortDefinition: 'Vom Dienstleister tatsächlich verwendetes Umrechnungsverhältnis zwischen gesendetem und erhaltenem Betrag.',
        detailedDefinition: 'Der angewandte Wechselkurs ist der transaktionsspezifische Kurs, der vom Dienstleister angegeben oder aus der Operation berechnet wird, ohne separat ausgewiesene Gebühren. Datum, Quelle und beteiligte Währungen sind zu dokumentieren. Er unterscheidet sich von einem Referenz- oder Tageskurs, der nur dem Vergleich und der Erklärung von Abweichungen dient.'
      },
      EN: {
        term: 'Applied exchange rate',
        shortDefinition: 'Conversion ratio actually used by the provider between the amount sent and the amount received.',
        detailedDefinition: 'The applied exchange rate is the transaction-specific rate stated by the provider or calculated from the operation, excluding separate fees. Its date, source and currency pair must be retained. It differs from a reference or daily rate, which is used only for comparison and explaining variances.'
      }
    }
  },
  'FIN-TAUX-CHANGE-REFERENCE': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Taux de change de référence',
        shortDefinition: 'Taux daté provenant d’une source identifiée, utilisé pour comparer ou convertir à titre indicatif.',
        detailedDefinition: 'Le taux de change de référence est une valeur datée issue d’une source identifiée, par exemple l’historique /fx-rates. Il sert à la lecture, à la comparaison ou à l’explication d’un écart. Il ne remplace jamais le taux réellement appliqué par un prestataire à une transaction, qui doit être conservé avec l’écriture financière concernée.'
      },
      DE: {
        term: 'Referenzwechselkurs',
        shortDefinition: 'Datierter Kurs aus einer benannten Quelle, der zum Vergleich oder zur indikativen Umrechnung dient.',
        detailedDefinition: 'Der Referenzwechselkurs ist ein datierter Wert aus einer benannten Quelle, zum Beispiel der Historie /fx-rates. Er dient der Anzeige, dem Vergleich oder der Erklärung einer Abweichung. Er ersetzt niemals den tatsächlich von einem Dienstleister auf eine Transaktion angewandten Kurs, der mit der betreffenden Finanzbuchung aufzubewahren ist.'
      },
      EN: {
        term: 'Reference exchange rate',
        shortDefinition: 'Dated rate from an identified source, used for comparison or indicative conversion.',
        detailedDefinition: 'A reference exchange rate is a dated value from an identified source, such as the /fx-rates history. It supports display, comparison or explanation of a variance. It never replaces the rate actually applied by a provider to a transaction, which must be retained with the related financial entry.'
      }
    }
  },
  'FIN-ECRITURE-FINANCIERE': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Écriture financière',
        shortDefinition: 'Enregistrement daté d’une recette ou d’une dépense avec ses montants, sa devise et ses références disponibles.',
        detailedDefinition: 'Objet observé dans le module Finances M3S pour consigner une recette ou une dépense avec identifiant, référence, description, date, montants, devises, taux appliqué, catégorie et autres libellés disponibles. Cette écriture opérationnelle ne prouve pas à elle seule une qualification comptable, un paiement effectif ou un mouvement bancaire ; ces éléments exigent une source et un rapprochement adaptés.'
      },
      DE: {
        term: 'Finanzbuchung',
        shortDefinition: 'Datierter Eintrag einer Einnahme oder Ausgabe mit Beträgen, Währung und verfügbaren Referenzen.',
        detailedDefinition: 'Im M3S-Finanzmodul beobachtetes Objekt zur Erfassung einer Einnahme oder Ausgabe mit Kennung, Referenz, Beschreibung, Datum, Beträgen, Währungen, angewandtem Kurs, Kategorie und weiteren verfügbaren Bezeichnungen. Diese operative Buchung belegt allein weder eine buchhalterische Einordnung noch eine tatsächliche Zahlung oder Bankbewegung; dafür sind geeignete Quellen und ein Abgleich erforderlich.'
      },
      EN: {
        term: 'Financial entry',
        shortDefinition: 'A dated revenue or expense record with its amounts, currency and available references.',
        detailedDefinition: 'An object observed in the M3S Finance module for recording revenue or expense with an identifier, reference, description, date, amounts, currencies, applied rate, category and other available labels. This operational entry does not by itself prove an accounting classification, an effective payment or a bank movement; those require appropriate sources and reconciliation.'
      }
    }
  },
  'FIN-AGREGAT-GLOBAL': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Agrégat global',
        shortDefinition: 'Indicateur consolidé calculé sur le périmètre complet défini par une source dédiée.',
        detailedDefinition: 'Valeur synthétique provenant d’une source conçue pour couvrir l’ensemble du périmètre annoncé, par exemple un total de recettes ou de dépenses. Elle ne doit pas être reconstruite à partir de la seule page visible d’un registre. Un zéro réel reste différent d’une donnée indisponible, vide ou non chargée.'
      },
      DE: {
        term: 'Globales Aggregat',
        shortDefinition: 'Konsolidierter Indikator, der über den vollständigen, von einer eigenen Quelle definierten Umfang berechnet wird.',
        detailedDefinition: 'Zusammengefasster Wert aus einer Quelle, die den gesamten angekündigten Umfang abdecken soll, etwa die Summe der Einnahmen oder Ausgaben. Er darf nicht allein aus der sichtbaren Registerseite rekonstruiert werden. Ein tatsächlicher Nullwert unterscheidet sich von nicht verfügbaren, leeren oder nicht geladenen Daten.'
      },
      EN: {
        term: 'Global aggregate',
        shortDefinition: 'A consolidated indicator calculated over the full scope defined by a dedicated source.',
        detailedDefinition: 'A summary value from a source designed to cover the entire stated scope, such as total revenue or expense. It must not be rebuilt from only the visible page of a register. A real zero remains distinct from data that is unavailable, empty or not loaded.'
      }
    }
  },
  'FIN-EXTRAIT-CHARGE': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Extrait chargé',
        shortDefinition: 'Sous-ensemble d’enregistrements actuellement reçu ou affiché après pagination, limite ou filtre.',
        detailedDefinition: 'Partie des données disponible dans la vue courante, souvent limitée par une page, un nombre maximal de lignes ou des critères de recherche. Sa somme décrit uniquement cet extrait tant que la source ne garantit pas un périmètre complet ; elle ne doit donc pas être présentée comme un total global.'
      },
      DE: {
        term: 'Geladener Auszug',
        shortDefinition: 'Teilmenge der aktuell empfangenen oder angezeigten Einträge nach Seitenteilung, Begrenzung oder Filter.',
        detailedDefinition: 'Der in der aktuellen Ansicht verfügbare Teil der Daten, häufig begrenzt durch eine Seite, eine Höchstzahl von Zeilen oder Suchkriterien. Seine Summe beschreibt nur diesen Auszug, solange die Quelle keinen vollständigen Umfang garantiert, und darf daher nicht als globaler Gesamtwert dargestellt werden.'
      },
      EN: {
        term: 'Loaded extract',
        shortDefinition: 'The subset of records currently received or displayed after pagination, limits or filters.',
        detailedDefinition: 'The portion of data available in the current view, often limited by a page, maximum row count or search criteria. Its sum describes only that extract unless the source guarantees complete scope, so it must not be presented as a global total.'
      }
    }
  },
  'DATA-RELATION-REFERENTIELLE': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Relation référentielle',
        shortDefinition: 'Lien contrôlé entre deux objets gouvernés au moyen d’identifiants stables et vérifiables.',
        detailedDefinition: 'Relation qui rattache, par exemple, une dépense à un projet, une tâche, un actif, un fournisseur ou un document GED à l’aide d’une clé gouvernée. Un nom libre, un libellé ou un nom de fichier peut aider à lire les données, mais ne prouve pas à lui seul l’existence d’une relation référentielle.'
      },
      DE: {
        term: 'Referenzbeziehung',
        shortDefinition: 'Kontrollierte Verbindung zwischen zwei geregelten Objekten mittels stabiler und überprüfbarer Kennungen.',
        detailedDefinition: 'Beziehung, die beispielsweise eine Ausgabe über einen geregelten Schlüssel mit einem Projekt, einer Aufgabe, einem Vermögenswert, einem Lieferanten oder einem DMS-Dokument verbindet. Ein Freitextname, eine Bezeichnung oder ein Dateiname erleichtert die Lesung, belegt allein jedoch keine Referenzbeziehung.'
      },
      EN: {
        term: 'Referential relationship',
        shortDefinition: 'A controlled link between two governed objects using stable, verifiable identifiers.',
        detailedDefinition: 'A relationship linking, for example, an expense to a project, task, asset, supplier or DMS document through a governed key. A free-text name, label or file name may aid reading, but does not by itself prove that a referential relationship exists.'
      }
    }
  },
  'FIN-JUSTIFICATIF-FINANCIER': {
    version: 'V5.8-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Justificatif financier',
        shortDefinition: 'Pièce fiable utilisée pour soutenir et rapprocher une opération financière enregistrée.',
        detailedDefinition: 'Document ou trace comme une facture, un reçu, un relevé, une confirmation de transfert ou une preuve de paiement, conservé avec sa date, sa provenance, sa version et son niveau d’accès. Le justificatif soutient le contrôle d’une opération, mais ne signifie pas automatiquement que celle-ci est approuvée, correctement imputée ou juridiquement conforme.'
      },
      DE: {
        term: 'Finanzbeleg',
        shortDefinition: 'Verlässlicher Nachweis zur Begründung und Abstimmung eines erfassten Finanzvorgangs.',
        detailedDefinition: 'Dokument oder Spur wie Rechnung, Quittung, Auszug, Überweisungsbestätigung oder Zahlungsnachweis, aufbewahrt mit Datum, Herkunft, Version und Zugriffsstufe. Der Beleg unterstützt die Kontrolle eines Vorgangs, bedeutet jedoch nicht automatisch, dass dieser genehmigt, korrekt zugeordnet oder rechtlich konform ist.'
      },
      EN: {
        term: 'Financial supporting evidence',
        shortDefinition: 'Reliable evidence used to support and reconcile a recorded financial operation.',
        detailedDefinition: 'A document or trace such as an invoice, receipt, statement, transfer confirmation or proof of payment, retained with its date, provenance, version and access level. The evidence supports control of an operation, but does not automatically mean that it is approved, correctly allocated or legally compliant.'
      }
    }
  },
  'ADM-PORTEFEUILLE-DOSSIERS': {
    version: 'V5.7-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Portefeuille des grands dossiers et chantiers',
        shortDefinition: 'Vue consolidée des affaires, projets, incidents et chantiers prioritaires à piloter transversalement.',
        detailedDefinition: 'Regroupement gouverné d’objets de nature différente qui nécessitent une vision commune de leur responsable, dernier état vérifié, prochaine action, risque, source et date. Le portefeuille facilite l’arbitrage sans transformer tous les objets en projets ni inventer un pourcentage d’avancement commun.'
      },
      DE: {
        term: 'Portfolio wichtiger Akten und Vorhaben',
        shortDefinition: 'Konsolidierte Sicht auf prioritäre Vorgänge, Projekte, Vorfälle und Vorhaben zur funktionsübergreifenden Steuerung.',
        detailedDefinition: 'Gesteuerte Zusammenführung unterschiedlicher Objekte, die eine gemeinsame Sicht auf Verantwortung, letzten geprüften Stand, nächsten Schritt, Risiko, Quelle und Datum benötigen. Das Portfolio unterstützt Entscheidungen, ohne alle Objekte zu Projekten zu erklären oder einen gemeinsamen Fortschrittswert zu erfinden.'
      },
      EN: {
        term: 'Portfolio of major files and workstreams',
        shortDefinition: 'A consolidated view of priority matters, projects, incidents and workstreams requiring cross-functional steering.',
        detailedDefinition: 'A governed grouping of different types of objects that need a shared view of their owner, latest verified state, next action, risk, source and date. The portfolio supports decisions without turning every object into a project or inventing a common progress percentage.'
      }
    }
  },
  'ADM-DERNIERE-VERIFICATION': {
    version: 'V5.7-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Date de dernière vérification',
        shortDefinition: 'Date à laquelle l’état affiché d’un dossier a été contrôlé pour la dernière fois à partir de sa source.',
        detailedDefinition: 'Repère de fraîcheur documentaire qui indique quand la source soutenant un état a été consultée ou confirmée. Elle ne prouve ni que le dossier n’a pas évolué depuis, ni que son contenu est complet ; un état ancien doit être actualisé avant une décision importante.'
      },
      DE: {
        term: 'Datum der letzten Prüfung',
        shortDefinition: 'Datum, an dem der angezeigte Stand einer Akte zuletzt anhand ihrer Quelle geprüft wurde.',
        detailedDefinition: 'Dokumentarischer Aktualitätshinweis, der festhält, wann die Quelle eines angezeigten Stands zuletzt eingesehen oder bestätigt wurde. Er beweist weder, dass sich der Vorgang seither nicht geändert hat, noch dass er vollständig ist; ein älterer Stand ist vor wichtigen Entscheidungen zu aktualisieren.'
      },
      EN: {
        term: 'Last verification date',
        shortDefinition: 'The date on which a file’s displayed state was last checked against its source.',
        detailedDefinition: 'A documentary freshness marker recording when the source supporting a displayed state was last consulted or confirmed. It does not prove that the matter has not changed since or that the record is complete; an older state must be refreshed before an important decision.'
      }
    }
  },
  'ADM-ARCHITECTURE-FONCTIONNELLE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Architecture fonctionnelle',
        shortDefinition: 'Vue structurée des fonctions, objets, relations, systèmes et sources nécessaires à une activité.',
        detailedDefinition: "Représentation de la manière dont une fonction comme Administration est organisée et reliée au reste de 2SG/M3S. Elle décrit les responsabilités, objets métier, échanges, systèmes d’appui et sources maîtresses, sans constituer un organigramme hiérarchique ni imposer un logiciel précis."
      },
      DE: {
        term: 'Funktionale Architektur',
        shortDefinition: 'Strukturierte Sicht auf Funktionen, Objekte, Beziehungen, Systeme und Quellen einer Tätigkeit.',
        detailedDefinition: 'Darstellung, wie eine Funktion wie Verwaltung aufgebaut und mit dem übrigen 2SG-/M3S-System verbunden ist. Sie beschreibt Verantwortlichkeiten, Fachobjekte, Austausch, unterstützende Systeme und maßgebliche Quellen, ohne ein hierarchisches Organigramm oder eine bestimmte Software vorzugeben.'
      },
      EN: {
        term: 'Functional architecture',
        shortDefinition: 'A structured view of the functions, objects, relationships, systems and sources required by an activity.',
        detailedDefinition: 'A representation of how a function such as Administration is organised and connected to the rest of 2SG/M3S. It describes responsibilities, business objects, exchanges, supporting systems and master sources without being a hierarchical organisation chart or prescribing specific software.'
      }
    }
  },
  'ADM-PROCESSUS': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Processus',
        shortDefinition: 'Enchaînement coordonné d’activités qui transforme une demande ou une ressource en résultat vérifiable.',
        detailedDefinition: 'Suite organisée d’activités reliées par un déclencheur, des rôles, des contrôles, des informations et un résultat attendu. Un processus traverse parfois plusieurs fonctions et précise le flux global, tandis qu’une procédure décrit une manière approuvée d’en exécuter une partie.'
      },
      DE: {
        term: 'Prozess',
        shortDefinition: 'Koordinierte Folge von Tätigkeiten, die eine Anfrage oder Ressource in ein überprüfbares Ergebnis überführt.',
        detailedDefinition: 'Geordnete Abfolge von Tätigkeiten mit Auslöser, Rollen, Kontrollen, Informationen und erwartetem Ergebnis. Ein Prozess kann mehrere Funktionen durchlaufen und beschreibt den Gesamtfluss, während ein Verfahren die genehmigte Ausführung eines Teils davon festlegt.'
      },
      EN: {
        term: 'Process',
        shortDefinition: 'A coordinated sequence of activities that turns a request or resource into a verifiable result.',
        detailedDefinition: 'An organised sequence of activities linked by a trigger, roles, controls, information and an expected result. A process may cross several functions and describes the overall flow, while a procedure sets out an approved way to perform part of it.'
      }
    }
  },
  'ADM-PROCEDURE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Procédure',
        shortDefinition: 'Façon approuvée d’exécuter une partie d’un processus avec des étapes, rôles, contrôles et preuves.',
        detailedDefinition: 'Description versionnée des actions à réaliser, de leur ordre, des responsabilités, contrôles, preuves attendues et exceptions possibles. Une procédure rend l’exécution reproductible et traçable sans remplacer le jugement professionnel ni la validation humaine requise.'
      },
      DE: {
        term: 'Verfahren',
        shortDefinition: 'Genehmigte Art, einen Teil eines Prozesses mit Schritten, Rollen, Kontrollen und Nachweisen auszuführen.',
        detailedDefinition: 'Versionierte Beschreibung der auszuführenden Handlungen, ihrer Reihenfolge, Verantwortlichkeiten, Kontrollen, erwarteten Nachweise und möglichen Ausnahmen. Ein Verfahren macht die Ausführung wiederholbar und nachvollziehbar, ersetzt jedoch weder fachliches Urteil noch erforderliche menschliche Freigaben.'
      },
      EN: {
        term: 'Procedure',
        shortDefinition: 'An approved way to perform part of a process using defined steps, roles, controls and evidence.',
        detailedDefinition: 'A versioned description of the actions to perform, their order, responsibilities, controls, expected evidence and possible exceptions. A procedure makes execution repeatable and traceable without replacing professional judgement or required human approval.'
      }
    }
  },
  'ADM-MANUEL-PROCEDURES': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Manuel de procédures',
        shortDefinition: 'Ensemble gouverné des procédures applicables, de leurs responsables, versions et règles communes.',
        detailedDefinition: 'Référentiel organisé qui rassemble les procédures validées d’une institution ou d’une fonction, leur périmètre, leurs propriétaires, versions, contrôles et modalités de mise à jour. Chaque procédure reste identifiable et reliée au processus qu’elle soutient.'
      },
      DE: {
        term: 'Verfahrenshandbuch',
        shortDefinition: 'Gesteuerte Sammlung anwendbarer Verfahren mit Verantwortlichen, Versionen und gemeinsamen Regeln.',
        detailedDefinition: 'Geordnete Referenz, die validierte Verfahren einer Institution oder Funktion samt Geltungsbereich, Verantwortlichen, Versionen, Kontrollen und Aktualisierungsregeln zusammenführt. Jedes Verfahren bleibt eindeutig erkennbar und mit dem unterstützten Prozess verbunden.'
      },
      EN: {
        term: 'Procedures manual',
        shortDefinition: 'A governed set of applicable procedures, their owners, versions and common rules.',
        detailedDefinition: 'An organised reference bringing together the validated procedures of an institution or function, their scope, owners, versions, controls and update rules. Each procedure remains identifiable and linked to the process it supports.'
      }
    }
  },
  'ADM-DOSSIER': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Dossier administratif',
        shortDefinition: 'Regroupement des informations et pièces relatives à une affaire, une décision, un projet ou une obligation.',
        detailedDefinition: 'Ensemble structuré de documents, données, échanges, décisions et preuves rattachés à un même objet administratif. Il possède un identifiant, un responsable, un statut, un niveau de confidentialité et un emplacement GED afin de rester traçable pendant tout son cycle de vie.'
      },
      DE: {
        term: 'Verwaltungsakte',
        shortDefinition: 'Zusammenstellung der Informationen und Unterlagen zu einem Vorgang, einer Entscheidung, einem Projekt oder einer Pflicht.',
        detailedDefinition: 'Strukturierte Gesamtheit von Dokumenten, Daten, Austausch, Entscheidungen und Nachweisen zu demselben Verwaltungsvorgang. Sie verfügt über Kennung, Verantwortung, Status, Vertraulichkeitsstufe und DMS-Ablageort, damit ihr Lebenszyklus nachvollziehbar bleibt.'
      },
      EN: {
        term: 'Administrative file',
        shortDefinition: 'A collection of information and records relating to a matter, decision, project or obligation.',
        detailedDefinition: 'A structured set of documents, data, exchanges, decisions and evidence linked to the same administrative subject. It has an identifier, owner, status, confidentiality level and DMS location so its lifecycle remains traceable.'
      }
    }
  },
  'ADM-ARCHIVE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Archive',
        shortDefinition: 'Dossier ou document clos conservé avec son contexte, sa version, sa durée et ses droits d’accès.',
        detailedDefinition: 'Document ou dossier qui n’est plus en traitement actif mais reste conservé selon une règle définie. Son statut, sa version, sa provenance, sa durée de conservation et ses droits d’accès doivent rester visibles ; une archive ne se confond pas avec un brouillon ou un document actif.'
      },
      DE: {
        term: 'Archivgut',
        shortDefinition: 'Abgeschlossene Akte oder abgeschlossenes Dokument, das mit Kontext, Version, Dauer und Zugriffsrechten aufbewahrt wird.',
        detailedDefinition: 'Dokument oder Akte, die nicht mehr aktiv bearbeitet, aber nach einer festgelegten Regel aufbewahrt wird. Status, Version, Herkunft, Aufbewahrungsdauer und Zugriffsrechte bleiben sichtbar; Archivgut ist weder Entwurf noch aktives Dokument.'
      },
      EN: {
        term: 'Archive record',
        shortDefinition: 'A closed file or document retained with its context, version, retention period and access rights.',
        detailedDefinition: 'A document or file no longer under active processing but retained according to a defined rule. Its status, version, provenance, retention period and access rights remain visible; an archive record is distinct from a draft or active document.'
      }
    }
  },
  'ADM-CONTROLE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Contrôle administratif',
        shortDefinition: 'Vérification définie à l’avance pour confirmer un état, une règle, une autorisation ou une preuve.',
        detailedDefinition: 'Point de vérification doté d’un objet, d’un responsable, de critères, d’une date et d’une preuve attendue. Il rend un processus plus fiable et traçable, mais ne vaut ni validation juridique, ni audit, ni réception lorsque ces actes relèvent d’un autre rôle.'
      },
      DE: {
        term: 'Verwaltungskontrolle',
        shortDefinition: 'Vorab festgelegte Prüfung zur Bestätigung eines Zustands, einer Regel, einer Genehmigung oder eines Nachweises.',
        detailedDefinition: 'Prüfpunkt mit Gegenstand, Verantwortung, Kriterien, Datum und erwartetem Nachweis. Er erhöht Zuverlässigkeit und Nachvollziehbarkeit eines Prozesses, ersetzt aber weder rechtliche Freigabe noch Audit oder Abnahme, wenn diese anderen Rollen zugeordnet sind.'
      },
      EN: {
        term: 'Administrative control',
        shortDefinition: 'A predefined check used to confirm a status, rule, authorisation or item of evidence.',
        detailedDefinition: 'A verification point with a subject, owner, criteria, date and expected evidence. It makes a process more reliable and traceable but does not constitute legal approval, audit or acceptance when those acts belong to another role.'
      }
    }
  },
  'ADM-RAPPORT-ACTIVITE': {
    version: 'V5.6-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Rapport d’activité',
        shortDefinition: 'Synthèse périodique, sourcée et validée des résultats, décisions, risques et suites d’une activité.',
        detailedDefinition: 'Document consolidé pour une période déterminée à partir de journaux, registres, indicateurs et preuves identifiables. Il distingue les faits des interprétations, indique ses responsables et son statut, et ne devient institutionnel qu’après la validation ou l’adoption requise.'
      },
      DE: {
        term: 'Tätigkeitsbericht',
        shortDefinition: 'Periodische, belegte und validierte Synthese von Ergebnissen, Entscheidungen, Risiken und Folgeschritten einer Tätigkeit.',
        detailedDefinition: 'Für einen bestimmten Zeitraum konsolidiertes Dokument auf Grundlage identifizierbarer Journale, Register, Kennzahlen und Nachweise. Es trennt Fakten von Interpretationen, nennt Verantwortungen und Status und wird erst nach der erforderlichen Validierung oder Annahme institutionell.'
      },
      EN: {
        term: 'Activity report',
        shortDefinition: 'A periodic, sourced and validated synthesis of an activity’s results, decisions, risks and next steps.',
        detailedDefinition: 'A document consolidated for a defined period from identifiable journals, registers, indicators and evidence. It separates facts from interpretations, states its owners and status, and becomes institutional only after the required validation or adoption.'
      }
    }
  },
  'ADM-PERIODE-REFERENCE': {
    version: 'V5.6-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Période de référence',
        shortDefinition: 'Intervalle daté auquel se rapportent les faits, mesures et conclusions d’un document ou indicateur.',
        detailedDefinition: 'Date ou intervalle de début et de fin définissant ce qui entre dans une synthèse, un rapport ou une mesure. La période de référence doit rester distincte de la date de rédaction, de validation ou de publication afin d’éviter les comparaisons trompeuses.'
      },
      DE: {
        term: 'Bezugszeitraum',
        shortDefinition: 'Datierter Zeitraum, auf den sich Fakten, Messwerte und Aussagen eines Dokuments oder einer Kennzahl beziehen.',
        detailedDefinition: 'Datum oder Intervall mit Beginn und Ende, das festlegt, welche Inhalte in eine Synthese, einen Bericht oder eine Messung einfließen. Der Bezugszeitraum ist von Erstellungs-, Validierungs- und Veröffentlichungsdatum zu unterscheiden, um irreführende Vergleiche zu vermeiden.'
      },
      EN: {
        term: 'Reference period',
        shortDefinition: 'The dated interval to which the facts, measurements and conclusions of a document or indicator relate.',
        detailedDefinition: 'A date or start-to-end interval defining what is included in a synthesis, report or measurement. The reference period remains distinct from drafting, validation and publication dates to prevent misleading comparisons.'
      }
    }
  },
  'ADM-VERSION-CONSOLIDEE': {
    version: 'V5.6-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Version consolidée',
        shortDefinition: 'Version réunissant plusieurs contributions ou sources contrôlées, sans effacer leur provenance.',
        detailedDefinition: 'État d’un document obtenu après regroupement, dédoublonnage et contrôle de contributions identifiées. Une version consolidée n’est pas automatiquement validée, signée ou adoptée ; son statut, ses sources, son auteur et son validateur doivent rester visibles.'
      },
      DE: {
        term: 'Konsolidierte Version',
        shortDefinition: 'Version, die mehrere geprüfte Beiträge oder Quellen zusammenführt, ohne deren Herkunft zu verbergen.',
        detailedDefinition: 'Dokumentenstand nach Zusammenführung, Dublettenbereinigung und Prüfung identifizierter Beiträge. Eine konsolidierte Version ist nicht automatisch validiert, unterzeichnet oder angenommen; Status, Quellen, Autor und validierende Stelle müssen sichtbar bleiben.'
      },
      EN: {
        term: 'Consolidated version',
        shortDefinition: 'A version that combines several controlled contributions or sources without obscuring their provenance.',
        detailedDefinition: 'A document state produced after combining, deduplicating and checking identified contributions. A consolidated version is not automatically validated, signed or adopted; its status, sources, author and validator must remain visible.'
      }
    }
  },
  'ADM-CONFORMITE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Conformité',
        shortDefinition: 'Organisation du suivi des obligations légales, réglementaires, statutaires et internes applicables à 2SG.',
        detailedDefinition: 'Démarche visant à identifier les obligations applicables, leurs sources, responsables, échéances, risques et preuves. Elle permet de suivre et documenter la situation, sans déclarer automatiquement qu’une institution ou un acte est juridiquement conforme et sans remplacer un avis professionnel compétent.'
      },
      DE: {
        term: 'Compliance',
        shortDefinition: 'Organisation der Überwachung rechtlicher, regulatorischer, statutarischer und interner Pflichten von 2SG.',
        detailedDefinition: 'Vorgehen zur Ermittlung anwendbarer Pflichten, ihrer Quellen, Verantwortlichen, Fristen, Risiken und Nachweise. Es ermöglicht die dokumentierte Nachverfolgung, erklärt jedoch weder eine Institution noch eine Handlung automatisch für rechtskonform und ersetzt keine fachkundige Rechtsberatung.'
      },
      EN: {
        term: 'Compliance',
        shortDefinition: 'The organised monitoring of legal, regulatory, statutory and internal obligations applicable to 2SG.',
        detailedDefinition: 'An approach for identifying applicable obligations, their sources, owners, deadlines, risks and evidence. It supports documented monitoring without automatically declaring an institution or act legally compliant and without replacing competent professional advice.'
      }
    }
  },
  'ADM-CORRESPONDANCE': {
    version: 'V5.4',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Correspondance administrative',
        shortDefinition: 'Message entrant ou sortant suivi comme un objet administratif avec responsable, statut et preuves.',
        detailedDefinition: 'Courrier, email, formulaire, message ou remise en main propre reçu ou émis dans un cadre institutionnel. La correspondance est enregistrée avec son expéditeur ou destinataire, sa date, son objet, son niveau de confidentialité, son responsable, les suites attendues et les pièces conservées dans la GED.'
      },
      DE: {
        term: 'Verwaltungskorrespondenz',
        shortDefinition: 'Ein- oder ausgehende Nachricht, die mit Verantwortung, Status und Nachweisen als Verwaltungsvorgang verfolgt wird.',
        detailedDefinition: 'Brief, E-Mail, Formular, Nachricht oder persönliche Übergabe, die in einem institutionellen Rahmen empfangen oder versendet wird. Erfasst werden Absender oder Empfänger, Datum, Betreff, Vertraulichkeit, Verantwortung, erwartete Folgemaßnahmen und die im DMS aufbewahrten Unterlagen.'
      },
      EN: {
        term: 'Administrative correspondence',
        shortDefinition: 'An incoming or outgoing message tracked as an administrative object with an owner, status and evidence.',
        detailedDefinition: 'A letter, email, form, message or hand-delivered item received or issued in an institutional context. Correspondence is registered with sender or recipient, date, subject, confidentiality level, owner, expected follow-up and supporting records retained in the DMS.'
      }
    }
  },
  'RH-MEMBRE-FONDATEUR': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Membre fondateur',
        shortDefinition: 'Personne à l’origine de 2SG qui porte durablement le projet et participe à sa gouvernance fondatrice.',
        detailedDefinition: 'Statut institutionnel attribué aux personnes ayant initié, constitué et soutenu durablement 2SG. Selon la règle candidate actuelle, les membres fondateurs disposent des droits d’administration M3S, sans que cela autorise l’accès aux espaces personnels d’autrui ni aux informations spécialement restreintes.'
      },
      DE: {
        term: 'Gründungsmitglied',
        shortDefinition: 'Person, die 2SG mitbegründet hat, das Projekt dauerhaft trägt und an seiner Gründungsgouvernance mitwirkt.',
        detailedDefinition: 'Institutioneller Status für Personen, die 2SG initiiert, gegründet und dauerhaft unterstützt haben. Nach der derzeitigen Kandidatenregel verfügen Gründungsmitglieder über M3S-Administrationsrechte, jedoch nicht automatisch über Zugriff auf persönliche Bereiche anderer oder besonders geschützte Informationen.'
      },
      EN: {
        term: 'Founding member',
        shortDefinition: 'A person who originated 2SG, supports the project over time and participates in its founding governance.',
        detailedDefinition: 'An institutional status for people who initiated, established and have durably supported 2SG. Under the current candidate rule, founding members hold M3S administration rights, without automatic access to another person’s private area or specifically restricted information.'
      }
    }
  },
  'RH-MEMBRE-ASSOCIE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Membre associé',
        shortDefinition: 'Membre de 2SG qui porte une fonction ou une contribution reconnue sans disposer du droit d’administration global.',
        detailedDefinition: 'Statut institutionnel distinct du membre fondateur et du personnel d’appui. Le membre associé dispose de droits utilisateur et de droits fonctionnels élargis dans son propre périmètre. Toute dérogation supplémentaire doit être autorisée, limitée et traçable.'
      },
      DE: {
        term: 'Assoziiertes Mitglied',
        shortDefinition: '2SG-Mitglied mit anerkannter Funktion oder Mitwirkung, jedoch ohne globales Administrationsrecht.',
        detailedDefinition: 'Institutioneller Status, der sich von Gründungsmitglied und Unterstützungspersonal unterscheidet. Ein assoziiertes Mitglied verfügt über Benutzerrechte und erweiterte funktionale Rechte im eigenen Bereich. Jede zusätzliche Ausnahme muss genehmigt, begrenzt und nachvollziehbar sein.'
      },
      EN: {
        term: 'Associate member',
        shortDefinition: 'A 2SG member with a recognised function or contribution but no global administration right.',
        detailedDefinition: 'An institutional status distinct from a founding member and support staff. An associate member has user rights and expanded functional rights within their own scope. Any additional exception must be authorised, limited and traceable.'
      }
    }
  },
  'RH-PERSONNEL-APPUI': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Personnel d’appui',
        shortDefinition: 'Personne mobilisée pour soutenir l’exécution pratique, logistique, technique ou quotidienne des activités.',
        detailedDefinition: 'Personne employée, mandatée ou engagée selon un cadre à documenter pour réaliser des tâches d’appui. Ce statut ne confère ni la qualité de membre associé ni des droits d’administration. Le rattachement opérationnel, les horaires, la rémunération, les obligations et les preuves contractuelles doivent être précisés séparément.'
      },
      DE: {
        term: 'Unterstützungspersonal',
        shortDefinition: 'Person zur praktischen, logistischen, technischen oder täglichen Unterstützung der Tätigkeiten.',
        detailedDefinition: 'Person, die in einem zu dokumentierenden Rahmen beschäftigt, beauftragt oder eingesetzt wird, um Unterstützungsaufgaben zu erfüllen. Dieser Status verleiht weder die Stellung eines assoziierten Mitglieds noch Administrationsrechte. Operative Zuordnung, Arbeitszeiten, Vergütung, Pflichten und Vertragsnachweise sind gesondert festzuhalten.'
      },
      EN: {
        term: 'Support staff',
        shortDefinition: 'A person engaged to support the practical, logistical, technical or day-to-day execution of activities.',
        detailedDefinition: 'A person employed, mandated or otherwise engaged under a framework that must be documented to perform support tasks. This status grants neither associate membership nor administration rights. Operational reporting, hours, remuneration, duties and contractual evidence must be specified separately.'
      }
    }
  },
  'RH-FONCTION-ENTREPRISE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Fonction d’entreprise',
        shortDefinition: 'Ensemble stable de responsabilités et capacités nécessaires au fonctionnement de 2SG.',
        detailedDefinition: 'Domaine durable comme Administration, Finances, Ressources Humaines ou Production, défini par sa finalité, ses processus, décisions, compétences et résultats. Une fonction ne se confond ni avec une personne, ni avec un département, ni avec un projet, ni avec le module M3S qui l’outille.'
      },
      DE: {
        term: 'Unternehmensfunktion',
        shortDefinition: 'Dauerhafter Verantwortungs- und Fähigkeitsbereich, der für das Funktionieren von 2SG erforderlich ist.',
        detailedDefinition: 'Beständiger Bereich wie Verwaltung, Finanzen, Personalwesen oder Produktion, definiert durch Zweck, Prozesse, Entscheidungen, Kompetenzen und Ergebnisse. Eine Funktion ist weder eine Person noch eine Abteilung, ein Projekt oder das M3S-Modul, das sie unterstützt.'
      },
      EN: {
        term: 'Business function',
        shortDefinition: 'A stable set of responsibilities and capabilities required for 2SG to operate.',
        detailedDefinition: 'A durable domain such as Administration, Finance, Human Resources or Production, defined by its purpose, processes, decisions, skills and outcomes. A function is not a person, department, project or the M3S module that supports it.'
      }
    }
  },
  'RH-ROLE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Rôle',
        shortDefinition: 'Contribution attendue d’une personne ou d’un groupe dans une situation, un processus ou une fonction.',
        detailedDefinition: 'Ensemble cohérent d’attentes, d’actions et de décisions confiées dans un périmètre donné. Un rôle peut évoluer, être partagé ou temporaire ; il ne se confond ni avec la personne, ni avec son statut de membre, ni avec un droit technique dans M3S.'
      },
      DE: {
        term: 'Rolle',
        shortDefinition: 'Erwarteter Beitrag einer Person oder Gruppe in einer Situation, einem Prozess oder einer Funktion.',
        detailedDefinition: 'Zusammenhängende Erwartungen, Handlungen und Entscheidungen innerhalb eines festgelegten Bereichs. Eine Rolle kann sich ändern, geteilt oder befristet sein; sie ist weder mit der Person, ihrem Mitgliedsstatus noch mit einem technischen M3S-Recht gleichzusetzen.'
      },
      EN: {
        term: 'Role',
        shortDefinition: 'The expected contribution of a person or group in a situation, process or function.',
        detailedDefinition: 'A coherent set of expectations, actions and decisions assigned within a defined scope. A role may evolve, be shared or temporary; it is not the person, their membership status or a technical permission in M3S.'
      }
    }
  },
  'RH-RESPONSABILITE-FONCTIONNELLE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Responsabilité fonctionnelle',
        shortDefinition: 'Obligation de piloter un domaine ou un processus et de rendre compte des décisions et résultats relevant de ce périmètre.',
        detailedDefinition: 'Responsabilité attribuée pour organiser, décider, valider ou contrôler dans un champ métier déterminé. Dans la gouvernance horizontale de 2SG, elle ne crée pas une supériorité hiérarchique générale sur les autres membres ; les personnels d’appui peuvent toutefois avoir un rattachement opérationnel explicite.'
      },
      DE: {
        term: 'Funktionale Verantwortung',
        shortDefinition: 'Pflicht, einen Bereich oder Prozess zu steuern und über Entscheidungen und Ergebnisse dieses Bereichs Rechenschaft abzulegen.',
        detailedDefinition: 'Zugewiesene Verantwortung für Organisation, Entscheidung, Freigabe oder Kontrolle in einem bestimmten Fachbereich. In der horizontalen Governance von 2SG begründet sie keine allgemeine hierarchische Überordnung gegenüber anderen Mitgliedern; Unterstützungspersonal kann jedoch ausdrücklich operativ zugeordnet sein.'
      },
      EN: {
        term: 'Functional responsibility',
        shortDefinition: 'The duty to steer a domain or process and account for the decisions and outcomes within that scope.',
        detailedDefinition: 'Assigned responsibility to organise, decide, approve or control within a defined business field. In the horizontal governance of 2SG, it does not create general hierarchical authority over other members; support staff may nevertheless have an explicit operational reporting line.'
      }
    }
  },
  'RH-DELEGATION': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Délégation fonctionnelle',
        shortDefinition: 'Autorisation limitée accordée pour exécuter ou décider dans un périmètre, une durée et des conditions déterminés.',
        detailedDefinition: 'Mécanisme par lequel une personne ou instance compétente confie temporairement une action ou un niveau d’autorisation. La délégation doit préciser l’objet, le bénéficiaire, les limites, la durée, la preuve d’autorisation et la reddition attendue ; elle ne devient pas un droit permanent implicite.'
      },
      DE: {
        term: 'Funktionale Delegation',
        shortDefinition: 'Begrenzte Ermächtigung zum Handeln oder Entscheiden innerhalb eines festgelegten Umfangs, Zeitraums und bestimmter Bedingungen.',
        detailedDefinition: 'Mechanismus, durch den eine zuständige Person oder Instanz vorübergehend eine Handlung oder Berechtigungsstufe überträgt. Gegenstand, begünstigte Person, Grenzen, Dauer, Genehmigungsnachweis und erwartete Rechenschaft müssen festgelegt sein; daraus entsteht kein stillschweigendes Dauerrecht.'
      },
      EN: {
        term: 'Functional delegation',
        shortDefinition: 'A limited authorisation to act or decide within a defined scope, period and set of conditions.',
        detailedDefinition: 'A mechanism through which a competent person or body temporarily assigns an action or level of authority. It must state the purpose, beneficiary, limits, duration, evidence of approval and expected accountability; it does not become an implicit permanent right.'
      }
    }
  },
  'RH-EQUIPE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Équipe',
        shortDefinition: 'Groupe de personnes coordonné autour d’un territoire, d’une mission ou d’un ensemble de résultats communs.',
        detailedDefinition: 'Regroupement opérationnel comme Team Sénégal ou Team Zürich, utilisé pour coordonner les activités et les échanges. L’appartenance à une équipe ne définit pas à elle seule le statut institutionnel, le rôle, la fonction, la hiérarchie ou les droits d’accès de ses membres.'
      },
      DE: {
        term: 'Team',
        shortDefinition: 'Koordinierte Personengruppe für ein Gebiet, einen Auftrag oder gemeinsame Ergebnisse.',
        detailedDefinition: 'Operative Gruppierung wie Team Senegal oder Team Zürich zur Koordination von Tätigkeiten und Austausch. Die Teamzugehörigkeit legt für sich allein weder institutionellen Status, Rolle, Funktion, Hierarchie noch Zugriffsrechte der Mitglieder fest.'
      },
      EN: {
        term: 'Team',
        shortDefinition: 'A coordinated group of people organised around a territory, mission or shared outcomes.',
        detailedDefinition: 'An operational grouping such as Team Senegal or Team Zurich used to coordinate activities and exchanges. Team membership alone does not determine institutional status, role, function, hierarchy or access rights.'
      }
    }
  },
  'RH-COMPETENCE': {
    version: 'V5.5',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Compétence',
        shortDefinition: 'Capacité mobilisable combinant connaissances, savoir-faire et comportements pour produire un résultat attendu.',
        detailedDefinition: 'Capacité démontrée ou à développer dans un contexte donné. Elle peut être acquise par expérience, formation, pratique ou accompagnement et doit être reliée à des preuves adaptées. Une compétence ne se réduit ni à un diplôme, ni à un poste, ni à un droit d’accès.'
      },
      DE: {
        term: 'Kompetenz',
        shortDefinition: 'Einsetzbare Fähigkeit aus Wissen, Können und Verhalten zur Erzielung eines erwarteten Ergebnisses.',
        detailedDefinition: 'In einem bestimmten Kontext nachgewiesene oder zu entwickelnde Fähigkeit. Sie kann durch Erfahrung, Ausbildung, Praxis oder Begleitung erworben werden und ist mit geeigneten Nachweisen zu verbinden. Kompetenz ist weder nur ein Abschluss noch eine Stelle oder ein Zugriffsrecht.'
      },
      EN: {
        term: 'Competency',
        shortDefinition: 'An applicable capability combining knowledge, know-how and behaviours to produce an expected outcome.',
        detailedDefinition: 'A capability demonstrated or developed in a given context. It may be acquired through experience, training, practice or support and should be linked to appropriate evidence. A competency is not merely a qualification, position or access right.'
      }
    }
  },
  'STOCK-STOCK': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Stock',
        shortDefinition: "Ensemble d'articles suivis en quantité et par emplacement pour être utilisés, distribués, consommés ou vendus.",
        detailedDefinition: "Catégorie de suivi opérationnel qui rend visibles les quantités, unités, localisations, états et mouvements d'articles. L'inscription d'un bien dans le stock M3S ne constitue ni une qualification comptable définitive, ni une preuve juridique de propriété."
      },
      DE: {
        term: 'Bestand',
        shortDefinition: 'Gesamtheit der nach Menge und Standort geführten Artikel zur Nutzung, Verteilung, zum Verbrauch oder Verkauf.',
        detailedDefinition: 'Operative Nachverfolgungskategorie für Mengen, Einheiten, Standorte, Zustände und Bewegungen von Artikeln. Die Aufnahme eines Gutes in den M3S-Bestand stellt weder eine endgültige buchhalterische Einordnung noch einen rechtlichen Eigentumsnachweis dar.'
      },
      EN: {
        term: 'Stock',
        shortDefinition: 'A set of items tracked by quantity and location for use, distribution, consumption or sale.',
        detailedDefinition: 'An operational monitoring category that makes item quantities, units, locations, conditions and movements visible. Recording an item in M3S stock is neither a final accounting classification nor legal proof of ownership.'
      }
    }
  },
  'STOCK-INVENTAIRE': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Inventaire',
        shortDefinition: 'Relevé structuré et daté des biens observés ou enregistrés, avec leurs quantités, états et localisations.',
        detailedDefinition: "Liste de contrôle permettant de comparer les biens enregistrés aux biens réellement présents. Un inventaire fiable indique sa date, son périmètre, la personne responsable et les écarts constatés ; il ne remplace pas la comptabilité ni les justificatifs d'acquisition."
      },
      DE: {
        term: 'Inventar',
        shortDefinition: 'Strukturierte und datierte Erfassung beobachteter oder registrierter Güter mit Mengen, Zuständen und Standorten.',
        detailedDefinition: 'Kontrollliste zum Vergleich der registrierten mit den tatsächlich vorhandenen Gütern. Ein verlässliches Inventar nennt Datum, Umfang, verantwortliche Person und festgestellte Abweichungen; es ersetzt weder die Buchhaltung noch Erwerbsnachweise.'
      },
      EN: {
        term: 'Inventory',
        shortDefinition: 'A structured, dated record of observed or registered items with their quantities, conditions and locations.',
        detailedDefinition: 'A control list used to compare recorded items with those actually present. A reliable inventory states its date, scope, owner and identified discrepancies; it does not replace accounting records or acquisition evidence.'
      }
    }
  },
  'STOCK-LOCALISATION': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: "Localisation d'un bien",
        shortDefinition: "Dernier lieu connu et vérifié où un bien est conservé, utilisé ou déclaré en transit.",
        detailedDefinition: "Information opérationnelle à dater et à actualiser lors de chaque transfert. Elle doit distinguer un emplacement vérifié d'une localisation seulement déclarée et signaler explicitement les biens en transit ou dont l'emplacement reste à confirmer."
      },
      DE: {
        term: 'Standort eines Gutes',
        shortDefinition: 'Letzter bekannter und geprüfter Ort, an dem ein Gut aufbewahrt, genutzt oder als unterwegs gemeldet wird.',
        detailedDefinition: 'Operative Information, die bei jeder Verlagerung zu datieren und zu aktualisieren ist. Ein geprüfter Standort muss von einer lediglich gemeldeten Angabe unterschieden werden; Güter im Transit oder mit ungeklärtem Standort sind ausdrücklich zu kennzeichnen.'
      },
      EN: {
        term: 'Asset location',
        shortDefinition: 'The last known and verified place where an item is stored, used or reported in transit.',
        detailedDefinition: 'Operational information that must be dated and updated whenever an item moves. A verified location must be distinguished from a merely reported one, and items in transit or awaiting location confirmation must be identified explicitly.'
      }
    }
  },
  'STOCK-ETAT-BIEN': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: "État d'un bien",
        shortDefinition: "Condition physique ou fonctionnelle observée pour un bien à une date donnée.",
        detailedDefinition: "Qualification de suivi telle que neuf, bon état, seconde main ou à réparer. Elle doit être datée et, lorsque le risque le justifie, accompagnée d'une photo ou d'un contrôle ; elle ne détermine pas à elle seule la valeur financière du bien."
      },
      DE: {
        term: 'Zustand eines Gutes',
        shortDefinition: 'Zu einem bestimmten Datum beobachteter physischer oder funktionaler Zustand eines Gutes.',
        detailedDefinition: 'Nachverfolgungsangabe wie neu, guter Zustand, gebraucht oder zu reparieren. Sie ist zu datieren und bei entsprechendem Risiko durch Foto oder Kontrolle zu belegen; allein bestimmt sie nicht den finanziellen Wert des Gutes.'
      },
      EN: {
        term: 'Item condition',
        shortDefinition: 'The physical or functional condition observed for an item on a given date.',
        detailedDefinition: 'A monitoring classification such as new, good condition, second-hand or needs repair. It must be dated and, where risk warrants it, supported by a photograph or inspection; by itself it does not determine the item’s financial value.'
      }
    }
  },
  'ACTIF-ACTIF': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Actif',
        shortDefinition: "Ressource contrôlée ou utilisée par 2SG pour soutenir ses activités et produire une utilité future.",
        detailedDefinition: "Bien matériel, immatériel ou immobilier suivi parce qu'il contribue durablement aux activités de 2SG. Sa présence dans le registre opérationnel ne vaut ni reconnaissance comptable automatique, ni preuve de propriété ; ces dimensions nécessitent leurs sources et validations propres."
      },
      DE: {
        term: 'Vermögenswert',
        shortDefinition: 'Von 2SG kontrollierte oder genutzte Ressource zur Unterstützung der Tätigkeiten und zur Schaffung künftigen Nutzens.',
        detailedDefinition: 'Materielles, immaterielles oder unbewegliches Gut, das wegen seines dauerhaften Beitrags zu den Tätigkeiten von 2SG nachverfolgt wird. Die Aufnahme in das operative Register bedeutet weder automatische bilanzielle Anerkennung noch Eigentumsnachweis; dafür sind eigene Quellen und Freigaben erforderlich.'
      },
      EN: {
        term: 'Asset',
        shortDefinition: 'A resource controlled or used by 2SG to support its activities and provide future benefit.',
        detailedDefinition: 'A tangible, intangible or real-estate resource tracked because it contributes durably to 2SG activities. Inclusion in the operational register is neither automatic accounting recognition nor proof of ownership; those dimensions require their own sources and approvals.'
      }
    }
  },
  'ACTIF-IMMOBILISATION': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Immobilisation',
        shortDefinition: "Bien durable destiné à servir les activités au-delà d'un cycle d'utilisation courant.",
        detailedDefinition: "Catégorie candidate utilisée par le module pour isoler les biens durables, notamment immobiliers. La qualification comptable, la durée d'amortissement et la valeur au bilan relèvent de Finances et d'une validation compétente ; l'étiquette locale ne les établit pas."
      },
      DE: {
        term: 'Anlagegut',
        shortDefinition: 'Dauerhaftes Gut, das den Tätigkeiten über einen gewöhnlichen Nutzungszyklus hinaus dienen soll.',
        detailedDefinition: 'Im Modul verwendete Kandidatenkategorie zur Abgrenzung dauerhafter Güter, insbesondere Immobilien. Bilanzielle Einordnung, Abschreibungsdauer und Bilanzwert fallen in den Finanzbereich und erfordern fachliche Freigabe; die lokale Kennzeichnung legt sie nicht fest.'
      },
      EN: {
        term: 'Fixed asset',
        shortDefinition: 'A durable item intended to support activities beyond a normal operating cycle.',
        detailedDefinition: 'A candidate category used by the module to distinguish durable resources, especially real estate. Accounting classification, depreciation period and balance-sheet value belong to Finance and require competent validation; the local label does not establish them.'
      }
    }
  },
  'ACTIF-COUT-ACQUISITION': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: "Coût d'acquisition",
        shortDefinition: "Montant documenté engagé pour obtenir un bien, avec ses composantes et sa devise rendues visibles.",
        detailedDefinition: "Valeur historique fondée sur une facture, un reçu, un contrat ou une autre preuve. Le prix principal, les frais, taxes, transport et change doivent rester séparables lorsque leur traitement n'est pas validé ; le coût d'acquisition ne doit pas être confondu avec la valeur actuelle ou estimée."
      },
      DE: {
        term: 'Anschaffungskosten',
        shortDefinition: 'Dokumentierter Betrag für den Erwerb eines Gutes mit sichtbaren Bestandteilen und Währung.',
        detailedDefinition: 'Historischer Wert auf Grundlage von Rechnung, Beleg, Vertrag oder anderem Nachweis. Hauptpreis, Gebühren, Steuern, Transport und Währungsumrechnung müssen getrennt nachvollziehbar bleiben, solange ihre Behandlung nicht validiert ist; Anschaffungskosten sind nicht mit aktuellem oder geschätztem Wert gleichzusetzen.'
      },
      EN: {
        term: 'Acquisition cost',
        shortDefinition: 'The documented amount committed to obtain an item, with its components and currency made visible.',
        detailedDefinition: 'A historical value supported by an invoice, receipt, contract or other evidence. Principal price, fees, taxes, transport and foreign exchange must remain distinguishable until their treatment is validated; acquisition cost must not be confused with current or estimated value.'
      }
    }
  },
  'ACTIF-VALEUR-ESTIMEE': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Valeur estimée',
        shortDefinition: "Montant indicatif attribué à un bien selon une source, une date et une méthode explicites.",
        detailedDefinition: "Estimation de pilotage destinée à donner un ordre de grandeur. Elle doit indiquer son auteur ou sa source, sa date, sa devise et sa méthode ; elle ne remplace ni une expertise professionnelle, ni une valeur comptable, assurée ou juridiquement reconnue."
      },
      DE: {
        term: 'Geschätzter Wert',
        shortDefinition: 'Richtwert eines Gutes auf Grundlage einer ausdrücklich genannten Quelle, eines Datums und einer Methode.',
        detailedDefinition: 'Steuerungsschätzung zur Angabe einer Größenordnung. Autor oder Quelle, Datum, Währung und Methode müssen sichtbar sein; sie ersetzt weder ein professionelles Gutachten noch einen Buch-, Versicherungs- oder rechtlich anerkannten Wert.'
      },
      EN: {
        term: 'Estimated value',
        shortDefinition: 'An indicative amount assigned to an item using an explicit source, date and method.',
        detailedDefinition: 'A management estimate intended to provide an order of magnitude. Its author or source, date, currency and method must be visible; it does not replace a professional valuation, book value, insured value or legally recognised value.'
      }
    }
  },
  'ACTIF-REGISTRE-FONCIER': {
    version: 'V5.3',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Registre foncier opérationnel',
        shortDefinition: "Vue de suivi des terrains et parcelles reliée aux projets, titulaires déclarés, coûts et sources disponibles.",
        detailedDefinition: "Registre interne permettant à 2SG de retrouver les références, emplacements, flux d'acquisition et documents associés aux biens fonciers. Il ne remplace ni le cadastre, ni un titre foncier, ni une attestation officielle, ni le contrôle d'un professionnel compétent."
      },
      DE: {
        term: 'Operatives Grundstücksregister',
        shortDefinition: 'Nachverfolgungssicht für Grundstücke und Parzellen mit Projekten, gemeldeten Inhabern, Kosten und verfügbaren Quellen.',
        detailedDefinition: 'Internes Register, mit dem 2SG Referenzen, Standorte, Erwerbsflüsse und zugehörige Dokumente von Grundstücken auffinden kann. Es ersetzt weder Kataster noch Eigentumstitel, amtliche Bescheinigung oder Prüfung durch eine fachkundige Person.'
      },
      EN: {
        term: 'Operational land register',
        shortDefinition: 'A monitoring view of land and plots linked to projects, declared holders, costs and available sources.',
        detailedDefinition: 'An internal register enabling 2SG to retrieve references, locations, acquisition flows and documents associated with land assets. It does not replace the cadastre, a land title, an official certificate or review by a competent professional.'
      }
    }
  },
  'PROJ-JALON': {
    version: 'V5.1',
    status: 'validated',
    translations: {
      FR: {
        term: 'Jalon',
        shortDefinition: 'Point daté de contrôle, de décision, de livraison ou de réception, sans durée propre.',
        detailedDefinition: "Repère vérifiable dans le cycle d’un projet ou d’un plan. Un jalon indique qu’un résultat, une décision, une livraison ou une réception doit être contrôlé à une date donnée. Il n’est ni une tâche ni une phase et doit être relié à un responsable ainsi qu’à une preuve attendue."
      },
      DE: {
        term: 'Meilenstein',
        shortDefinition: 'Datierter Kontroll-, Entscheidungs-, Liefer- oder Abnahmepunkt ohne eigene Dauer.',
        detailedDefinition: 'Überprüfbarer Orientierungspunkt im Verlauf eines Projekts oder Plans. Ein Meilenstein zeigt an, dass ein Ergebnis, eine Entscheidung, eine Lieferung oder eine Abnahme zu einem bestimmten Datum kontrolliert werden muss. Er ist weder Aufgabe noch Phase und muss mit einer verantwortlichen Person sowie einem erwarteten Nachweis verknüpft sein.'
      },
      EN: {
        term: 'Milestone',
        shortDefinition: 'A dated control, decision, delivery or acceptance point with no duration of its own.',
        detailedDefinition: 'A verifiable reference point in the lifecycle of a project or plan. A milestone indicates that an outcome, decision, delivery or acceptance must be checked on a given date. It is neither a task nor a phase and must be linked to an owner and expected evidence.'
      }
    }
  },
  'PROJ-REVUE': {
    version: 'V5.1',
    status: 'validated',
    translations: {
      FR: {
        term: 'Revue de projet',
        shortDefinition: 'Contrôle périodique et factuel de l’état d’un projet, de ses risques, décisions, coûts et preuves.',
        detailedDefinition: 'Moment court et structuré où les responsables comparent la situation réelle au résultat attendu, identifient les changements, le prochain jalon, les blocages, les montants engagés, payés et restants ainsi que les preuves manquantes. La revue produit une décision ou des actions tracées et ne remplace ni la réception ni l’audit.'
      },
      DE: {
        term: 'Projektüberprüfung',
        shortDefinition: 'Regelmäßige, sachliche Prüfung von Projektstand, Risiken, Entscheidungen, Kosten und Nachweisen.',
        detailedDefinition: 'Kurzer, strukturierter Termin, bei dem die Verantwortlichen den tatsächlichen Stand mit dem erwarteten Ergebnis vergleichen und Änderungen, den nächsten Meilenstein, Blockaden, gebundene, bezahlte und offene Beträge sowie fehlende Nachweise feststellen. Die Prüfung führt zu einer dokumentierten Entscheidung oder zu nachverfolgbaren Maßnahmen und ersetzt weder Abnahme noch Audit.'
      },
      EN: {
        term: 'Project review',
        shortDefinition: 'A periodic, factual review of project status, risks, decisions, costs and evidence.',
        detailedDefinition: 'A short, structured checkpoint where owners compare actual status with the expected outcome and identify changes, the next milestone, blockers, committed, paid and remaining amounts, and missing evidence. The review produces a recorded decision or traceable actions and does not replace acceptance or audit.'
      }
    }
  },
  'CRM-PROSPECT': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Prospect',
        shortDefinition: 'Personne ou organisation correspondant à une cible et susceptible d’entrer dans une relation commerciale.',
        detailedDefinition: 'Contact identifié comme potentiellement intéressé par une offre 2SG, mais dont le besoin, le pouvoir de décision, les moyens ou le calendrier restent à qualifier. Un prospect n’est ni un client acquis ni une vente et doit conserver sa source ainsi que la prochaine action attendue.'
      },
      DE: {
        term: 'Interessent',
        shortDefinition: 'Person oder Organisation, die einer Zielgruppe entspricht und eine Geschäftsbeziehung eingehen könnte.',
        detailedDefinition: 'Ein Kontakt mit möglichem Interesse an einem 2SG-Angebot, dessen Bedarf, Entscheidungsbefugnis, Mittel oder Zeitplan noch zu qualifizieren sind. Ein Interessent ist weder ein gewonnener Kunde noch ein Verkauf; Quelle und nächste Aktion müssen nachvollziehbar bleiben.'
      },
      EN: {
        term: 'Prospect',
        shortDefinition: 'A person or organisation matching a target profile and potentially entering a commercial relationship.',
        detailedDefinition: 'A contact identified as potentially interested in a 2SG offer, whose need, decision authority, means or timing still require qualification. A prospect is neither an acquired customer nor a sale, and its source and next action must remain traceable.'
      }
    }
  },
  'CRM-LEAD': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Lead',
        shortDefinition: 'Signal ou contact commercial entrant qui doit encore être vérifié et qualifié.',
        detailedDefinition: 'Coordonnée, recommandation, demande ou manifestation d’intérêt recueillie par un canal identifié. Le lead précède généralement le prospect qualifié : il peut être pertinent, incomplet, doublonné ou hors cible et ne doit pas être présenté comme une opportunité confirmée.'
      },
      DE: {
        term: 'Lead',
        shortDefinition: 'Eingehendes geschäftliches Signal oder Kontakt, der noch geprüft und qualifiziert werden muss.',
        detailedDefinition: 'Kontaktdaten, Empfehlung, Anfrage oder Interessenbekundung aus einem identifizierten Kanal. Ein Lead liegt gewöhnlich vor dem qualifizierten Interessenten; er kann relevant, unvollständig, doppelt oder außerhalb der Zielgruppe sein und ist keine bestätigte Verkaufschance.'
      },
      EN: {
        term: 'Lead',
        shortDefinition: 'An incoming commercial signal or contact that still requires verification and qualification.',
        detailedDefinition: 'Contact details, a referral, request or expression of interest collected through an identified channel. A lead usually precedes a qualified prospect; it may be relevant, incomplete, duplicated or out of scope and must not be presented as a confirmed opportunity.'
      }
    }
  },
  'CRM-CLIENT': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Client',
        shortDefinition: 'Personne ou organisation engagée dans une relation commerciale établie avec 2SG.',
        detailedDefinition: 'Partie ayant accepté ou acquis une offre, avec une preuve adaptée comme un accord, une commande, un contrat ou une facture. Le client se distingue du prospect et du bénéficiaire social ; son statut doit rester relié aux offres, échanges, pièces et responsabilités autorisées.'
      },
      DE: {
        term: 'Kunde',
        shortDefinition: 'Person oder Organisation in einer bestehenden Geschäftsbeziehung mit 2SG.',
        detailedDefinition: 'Partei, die ein Angebot angenommen oder erworben hat, belegt etwa durch Vereinbarung, Bestellung, Vertrag oder Rechnung. Der Kunde unterscheidet sich vom Interessenten und vom sozialen Begünstigten; sein Status bleibt mit Angeboten, Austausch, Dokumenten und Zuständigkeiten verknüpft.'
      },
      EN: {
        term: 'Customer',
        shortDefinition: 'A person or organisation engaged in an established commercial relationship with 2SG.',
        detailedDefinition: 'A party that has accepted or acquired an offer, supported by appropriate evidence such as an agreement, order, contract or invoice. A customer differs from a prospect and a social beneficiary; its status remains linked to authorised offers, exchanges, documents and responsibilities.'
      }
    }
  },
  'CRM-OPPORTUNITE': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Opportunité commerciale',
        shortDefinition: 'Possibilité qualifiée de proposer une offre à un prospect ou à un client.',
        detailedDefinition: 'Dossier de pilotage reliant un besoin, une offre pressentie, un montant estimé, une phase, une probabilité, un responsable, une échéance et une prochaine action. Une opportunité est une hypothèse commerciale suivie ; elle ne constitue ni une vente ni un revenu acquis.'
      },
      DE: {
        term: 'Verkaufschance',
        shortDefinition: 'Qualifizierte Möglichkeit, einem Interessenten oder Kunden ein Angebot zu unterbreiten.',
        detailedDefinition: 'Steuerungsobjekt, das Bedarf, mögliches Angebot, Schätzbetrag, Phase, Wahrscheinlichkeit, Verantwortung, Termin und nächste Aktion verbindet. Eine Verkaufschance ist eine verfolgte geschäftliche Hypothese und weder ein Verkauf noch ein gesicherter Ertrag.'
      },
      EN: {
        term: 'Commercial opportunity',
        shortDefinition: 'A qualified possibility to propose an offer to a prospect or customer.',
        detailedDefinition: 'A steering record linking a need, possible offer, estimated amount, stage, probability, owner, deadline and next action. An opportunity is a tracked commercial hypothesis; it is neither a sale nor secured revenue.'
      }
    }
  },
  'CRM-PIPELINE': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Pipeline commercial',
        shortDefinition: 'Vue ordonnée des opportunités selon leur phase d’avancement.',
        detailedDefinition: 'Instrument de pilotage montrant les opportunités ouvertes, leurs montants estimés, probabilités, responsables, échéances et blocages. Le pipeline aide à prioriser et prévoir ; il ne transforme pas une estimation en commande, en facture ou en revenu certain.'
      },
      DE: {
        term: 'Vertriebspipeline',
        shortDefinition: 'Geordnete Sicht auf Verkaufschancen nach ihrem Bearbeitungsstand.',
        detailedDefinition: 'Steuerungsinstrument für offene Verkaufschancen mit Schätzbeträgen, Wahrscheinlichkeiten, Verantwortlichen, Terminen und Blockaden. Die Pipeline unterstützt Priorisierung und Vorschau; sie macht aus einer Schätzung keine Bestellung, Rechnung oder sicheren Ertrag.'
      },
      EN: {
        term: 'Sales pipeline',
        shortDefinition: 'An ordered view of opportunities by their stage of progress.',
        detailedDefinition: 'A steering instrument showing open opportunities, estimated amounts, probabilities, owners, deadlines and blockers. The pipeline supports prioritisation and forecasting; it does not turn an estimate into an order, invoice or certain revenue.'
      }
    }
  },
  'CRM-VENTE': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Vente',
        shortDefinition: 'Opération commerciale acceptée par le client et appuyée par une preuve vérifiable.',
        detailedDefinition: 'Résultat commercial confirmé par une commande, un contrat, une acceptation ou une autre pièce adaptée. Le CRM suit la relation et le passage à la vente ; Finance traite la facturation et l’encaissement, Production l’exécution et la GED conserve les pièces.'
      },
      DE: {
        term: 'Verkauf',
        shortDefinition: 'Vom Kunden angenommener Geschäftsvorgang mit überprüfbarem Nachweis.',
        detailedDefinition: 'Geschäftsergebnis, das durch Bestellung, Vertrag, Annahme oder einen anderen geeigneten Beleg bestätigt ist. Das CRM verfolgt Beziehung und Verkaufsabschluss; Finanzen bearbeitet Rechnung und Zahlung, Produktion die Ausführung und die DMS die Belege.'
      },
      EN: {
        term: 'Sale',
        shortDefinition: 'A commercial transaction accepted by the customer and supported by verifiable evidence.',
        detailedDefinition: 'A commercial outcome confirmed by an order, contract, acceptance or other appropriate evidence. CRM tracks the relationship and conversion to sale; Finance handles invoicing and collection, Production handles delivery and the DMS keeps the records.'
      }
    }
  },
  'CRM-PROCHAINE-ACTION': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Prochaine action CRM',
        shortDefinition: 'Action datée et attribuée qui doit faire progresser une relation ou une opportunité.',
        detailedDefinition: 'Étape concrète à réaliser après le dernier échange, avec un responsable, une échéance et un résultat attendu. Elle peut être un appel, une relance, une rencontre, un envoi d’offre ou une décision ; elle évite qu’un contact reste ouvert sans suite traçable.'
      },
      DE: {
        term: 'Nächste CRM-Aktion',
        shortDefinition: 'Datierte und zugewiesene Aktion zur Weiterentwicklung einer Beziehung oder Verkaufschance.',
        detailedDefinition: 'Konkreter Schritt nach dem letzten Austausch mit Verantwortlichem, Termin und erwartetem Ergebnis. Dies kann ein Anruf, eine Erinnerung, ein Treffen, ein Angebot oder eine Entscheidung sein und verhindert Kontakte ohne nachvollziehbare Folge.'
      },
      EN: {
        term: 'Next CRM action',
        shortDefinition: 'A dated and assigned action intended to move a relationship or opportunity forward.',
        detailedDefinition: 'A concrete step after the latest exchange, with an owner, due date and expected result. It may be a call, follow-up, meeting, offer or decision and prevents a contact from remaining open without a traceable next step.'
      }
    }
  },
  'SOC-DONATEUR': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Donateur',
        shortDefinition: 'Personne ou organisation qui apporte volontairement de l’argent, un bien ou un service sans contrepartie commerciale équivalente.',
        detailedDefinition: 'Source d’un don financier, matériel ou en service, identifiée selon le niveau de preuve disponible et les règles de confidentialité. Le donateur ne doit pas être assimilé automatiquement à un client, partenaire ou membre ; le don reste relié à sa date, sa nature, sa valeur et sa destination.'
      },
      DE: {
        term: 'Spender',
        shortDefinition: 'Person oder Organisation, die freiwillig Geld, Sachwerte oder Leistungen ohne gleichwertige geschäftliche Gegenleistung bereitstellt.',
        detailedDefinition: 'Quelle einer Geld-, Sach- oder Leistungsspende, identifiziert nach Beleglage und Vertraulichkeitsregeln. Ein Spender ist nicht automatisch Kunde, Partner oder Mitglied; die Spende bleibt mit Datum, Art, Wert und Zweck verbunden.'
      },
      EN: {
        term: 'Donor',
        shortDefinition: 'A person or organisation voluntarily providing money, goods or services without equivalent commercial consideration.',
        detailedDefinition: 'The source of a financial, in-kind or service donation, identified according to available evidence and confidentiality rules. A donor is not automatically a customer, partner or member; the donation remains linked to its date, nature, value and destination.'
      }
    }
  },
  'SOC-BENEFICIAIRE': {
    version: 'V5.1-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Bénéficiaire',
        shortDefinition: 'Personne, groupe ou organisation recevant un appui, un service ou un avantage lié à l’action de 2SG.',
        detailedDefinition: 'Destinataire d’une aide, d’un don, d’un projet ou d’un service social, enregistré uniquement avec les données nécessaires et les droits adaptés. Un bénéficiaire n’est pas automatiquement un client ; son identité, le motif, la décision, la preuve et la confidentialité doivent être proportionnés au suivi attendu.'
      },
      DE: {
        term: 'Begünstigter',
        shortDefinition: 'Person, Gruppe oder Organisation, die Unterstützung, eine Leistung oder einen Vorteil aus der Tätigkeit von 2SG erhält.',
        detailedDefinition: 'Empfänger von Hilfe, Spende, Projekt oder sozialer Leistung, erfasst nur mit notwendigen Daten und angemessenen Rechten. Ein Begünstigter ist nicht automatisch Kunde; Identität, Grund, Entscheidung, Nachweis und Vertraulichkeit müssen dem erforderlichen Nachweis entsprechen.'
      },
      EN: {
        term: 'Beneficiary',
        shortDefinition: 'A person, group or organisation receiving support, a service or a benefit through 2SG activity.',
        detailedDefinition: 'The recipient of aid, a donation, project or social service, recorded only with necessary data and appropriate access rights. A beneficiary is not automatically a customer; identity, reason, decision, evidence and confidentiality must be proportionate to the required follow-up.'
      }
    }
  },
  'PROD-COMMANDE-CLIENT': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Commande client',
        shortDefinition: 'Demande acceptée précisant ce qui doit être fourni à un client et dans quelles conditions.',
        detailedDefinition: 'Enregistrement reliant le client, le produit ou service attendu, les quantités, dates, conditions et preuves d’acceptation. La commande déclenche ou planifie l’exécution ; elle ne constitue à elle seule ni une livraison, ni une facture, ni un paiement.'
      },
      DE: {
        term: 'Kundenauftrag',
        shortDefinition: 'Angenommene Anfrage, die festlegt, was einem Kunden unter welchen Bedingungen geliefert werden soll.',
        detailedDefinition: 'Datensatz, der Kunde, erwartetes Produkt oder Leistung, Mengen, Termine, Bedingungen und Annahmenachweise verbindet. Der Auftrag löst die Ausführung aus oder plant sie; allein ist er weder Lieferung noch Rechnung oder Zahlung.'
      },
      EN: {
        term: 'Customer order',
        shortDefinition: 'An accepted request specifying what must be supplied to a customer and under which conditions.',
        detailedDefinition: 'A record linking the customer, expected product or service, quantities, dates, conditions and acceptance evidence. The order triggers or plans execution; by itself it is neither delivery, invoice nor payment.'
      }
    }
  },
  'PROD-ORDRE-FABRICATION': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Ordre de fabrication',
        shortDefinition: 'Instruction interne autorisée pour produire une quantité définie selon un cadre identifié.',
        detailedDefinition: 'Objet de pilotage portant une référence, un produit, une quantité, des dates, des étapes, des responsables et les contrôles attendus. Il peut découler d’une commande ou d’un besoin interne et ne prouve pas que la fabrication est terminée ou conforme.'
      },
      DE: {
        term: 'Fertigungsauftrag',
        shortDefinition: 'Autorisierte interne Anweisung, eine festgelegte Menge nach einem identifizierten Rahmen herzustellen.',
        detailedDefinition: 'Steuerungsobjekt mit Referenz, Produkt, Menge, Terminen, Schritten, Verantwortlichen und erwarteten Kontrollen. Es kann aus einem Kundenauftrag oder internem Bedarf entstehen und belegt weder Abschluss noch Konformität der Fertigung.'
      },
      EN: {
        term: 'Manufacturing order',
        shortDefinition: 'An authorised internal instruction to produce a defined quantity under an identified framework.',
        detailedDefinition: 'A steering object carrying a reference, product, quantity, dates, steps, owners and expected controls. It may arise from a customer order or internal need and does not prove that manufacturing is complete or compliant.'
      }
    }
  },
  'PROD-LOT-PRODUCTION': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Lot de production',
        shortDefinition: 'Ensemble d’unités fabriquées dans des conditions communes et suivies sous une même référence.',
        detailedDefinition: 'Regroupement utilisé pour relier quantité, période, ressources, composants, contrôles, incidents et résultats de fabrication. Le lot facilite la traçabilité ; sa présence ne garantit ni disponibilité en stock ni conformité sans preuve de contrôle.'
      },
      DE: {
        term: 'Produktionslos',
        shortDefinition: 'Gruppe von Einheiten, die unter gemeinsamen Bedingungen gefertigt und unter einer Referenz verfolgt werden.',
        detailedDefinition: 'Zusammenfassung zur Verknüpfung von Menge, Zeitraum, Ressourcen, Komponenten, Kontrollen, Vorfällen und Fertigungsergebnissen. Das Los unterstützt die Rückverfolgbarkeit; es garantiert weder Lagerverfügbarkeit noch Konformität ohne Prüfnachweis.'
      },
      EN: {
        term: 'Production batch',
        shortDefinition: 'A group of units manufactured under common conditions and tracked under one reference.',
        detailedDefinition: 'A grouping used to link quantity, period, resources, components, controls, incidents and manufacturing results. The batch supports traceability; it guarantees neither stock availability nor compliance without control evidence.'
      }
    }
  },
  'PROD-FABRICATION': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Fabrication',
        shortDefinition: 'Transformation contrôlée de ressources en un produit ou résultat attendu.',
        detailedDefinition: 'Exécution d’opérations planifiées mobilisant matières, équipements, compétences, temps et contrôles. La fabrication doit rester reliée à son ordre, ses étapes, quantités, responsables, écarts et preuves ; elle se distingue de l’achat, du stockage et de la livraison.'
      },
      DE: {
        term: 'Fertigung',
        shortDefinition: 'Kontrollierte Umwandlung von Ressourcen in ein erwartetes Produkt oder Ergebnis.',
        detailedDefinition: 'Ausführung geplanter Vorgänge mit Material, Ausrüstung, Fähigkeiten, Zeit und Kontrollen. Die Fertigung bleibt mit Auftrag, Schritten, Mengen, Verantwortlichen, Abweichungen und Nachweisen verbunden und unterscheidet sich von Einkauf, Lagerung und Lieferung.'
      },
      EN: {
        term: 'Manufacturing',
        shortDefinition: 'The controlled transformation of resources into an expected product or result.',
        detailedDefinition: 'The execution of planned operations using materials, equipment, skills, time and controls. Manufacturing remains linked to its order, steps, quantities, owners, deviations and evidence, and differs from purchasing, storage and delivery.'
      }
    }
  },
  'PROD-NOMENCLATURE': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Nomenclature de fabrication',
        shortDefinition: 'Liste structurée des composants et quantités nécessaires à un produit défini.',
        detailedDefinition: 'Référence versionnée décrivant matières, pièces, sous-ensembles et quantités théoriques nécessaires. Elle sert à préparer et contrôler la fabrication, mais ne confirme ni la disponibilité réelle des composants ni leur consommation effective.'
      },
      DE: {
        term: 'Stückliste',
        shortDefinition: 'Strukturierte Liste der Komponenten und Mengen, die für ein definiertes Produkt erforderlich sind.',
        detailedDefinition: 'Versionierte Referenz für Materialien, Teile, Baugruppen und theoretisch benötigte Mengen. Sie unterstützt Vorbereitung und Kontrolle der Fertigung, bestätigt aber weder die tatsächliche Verfügbarkeit noch den realen Verbrauch.'
      },
      EN: {
        term: 'Bill of materials',
        shortDefinition: 'A structured list of components and quantities required for a defined product.',
        detailedDefinition: 'A versioned reference describing materials, parts, subassemblies and theoretical quantities required. It supports manufacturing preparation and control but confirms neither actual component availability nor actual consumption.'
      }
    }
  },
  'PROD-GAMME-OPERATOIRE': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Gamme opératoire',
        shortDefinition: 'Séquence définie des opérations, ressources et contrôles nécessaires à une fabrication.',
        detailedDefinition: 'Cadre versionné indiquant l’ordre des étapes, les moyens, compétences, temps ou critères attendus. La gamme guide l’exécution ; le suivi réel doit encore enregistrer les dates, responsables, résultats, incidents et écarts observés.'
      },
      DE: {
        term: 'Arbeitsplan',
        shortDefinition: 'Definierte Abfolge von Vorgängen, Ressourcen und Kontrollen für eine Fertigung.',
        detailedDefinition: 'Versionierter Rahmen mit Reihenfolge der Schritte, Mitteln, Fähigkeiten, Zeiten oder erwarteten Kriterien. Der Arbeitsplan führt die Ausführung; die tatsächliche Verfolgung muss Termine, Verantwortliche, Ergebnisse, Vorfälle und Abweichungen erfassen.'
      },
      EN: {
        term: 'Routing',
        shortDefinition: 'A defined sequence of operations, resources and controls required for manufacturing.',
        detailedDefinition: 'A versioned framework indicating the order of steps, means, skills, times or expected criteria. The routing guides execution; actual tracking must still record dates, owners, results, incidents and observed deviations.'
      }
    }
  },
  'PROD-CONTROLE-QUALITE': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Contrôle qualité',
        shortDefinition: 'Vérification documentée d’un résultat par rapport à des critères acceptés.',
        detailedDefinition: 'Contrôle réalisé à une étape définie sur un produit, un lot ou une livraison, avec méthode, critères, responsable, date et résultat. Il peut accepter, réserver ou signaler une non-conformité ; il ne remplace pas automatiquement la réception du client.'
      },
      DE: {
        term: 'Qualitätskontrolle',
        shortDefinition: 'Dokumentierte Prüfung eines Ergebnisses anhand anerkannter Kriterien.',
        detailedDefinition: 'Prüfung an einem festgelegten Schritt für Produkt, Los oder Lieferung mit Methode, Kriterien, Verantwortung, Datum und Ergebnis. Sie kann freigeben, Vorbehalte festhalten oder eine Abweichung melden und ersetzt nicht automatisch die Kundenabnahme.'
      },
      EN: {
        term: 'Quality control',
        shortDefinition: 'A documented verification of a result against accepted criteria.',
        detailedDefinition: 'A control performed at a defined step on a product, batch or delivery, with method, criteria, owner, date and result. It may accept, reserve or flag a nonconformity and does not automatically replace customer acceptance.'
      }
    }
  },
  'PROD-FOURNISSEUR': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Fournisseur',
        shortDefinition: 'Partie externe qui propose ou fournit un bien, une matière ou un service à 2SG.',
        detailedDefinition: 'Personne ou organisation reliée à des offres, commandes, livraisons, factures, paiements et évaluations selon le besoin. Une mention dans une dépense ou un stock peut identifier un fournisseur candidat ; sa qualification et son statut exigent des preuves et responsabilités adaptées.'
      },
      DE: {
        term: 'Lieferant',
        shortDefinition: 'Externe Partei, die 2SG Waren, Material oder Leistungen anbietet oder liefert.',
        detailedDefinition: 'Person oder Organisation, die je nach Bedarf mit Angeboten, Bestellungen, Lieferungen, Rechnungen, Zahlungen und Bewertungen verbunden ist. Eine Erwähnung in Ausgabe oder Bestand kann einen Lieferantenkandidaten anzeigen; Qualifizierung und Status benötigen geeignete Nachweise und Zuständigkeiten.'
      },
      EN: {
        term: 'Supplier',
        shortDefinition: 'An external party offering or supplying goods, materials or services to 2SG.',
        detailedDefinition: 'A person or organisation linked as needed to quotes, orders, deliveries, invoices, payments and evaluations. A mention in an expense or stock record may identify a candidate supplier; qualification and status require appropriate evidence and responsibilities.'
      }
    }
  },
  'PROD-LIVRAISON': {
    version: 'V5.2-candidate',
    status: 'candidate',
    translations: {
      FR: {
        term: 'Livraison',
        shortDefinition: 'Remise tracée d’un produit ou résultat à un destinataire identifié.',
        detailedDefinition: 'Événement reliant commande, quantités remises, date, lieu, état, transport, destinataire et preuve. Une livraison peut être partielle ou assortie de réserves ; elle ne signifie pas automatiquement réception définitive, facturation correcte ou paiement.'
      },
      DE: {
        term: 'Lieferung',
        shortDefinition: 'Nachvollziehbare Übergabe eines Produkts oder Ergebnisses an einen identifizierten Empfänger.',
        detailedDefinition: 'Ereignis, das Auftrag, übergebene Mengen, Datum, Ort, Zustand, Transport, Empfänger und Nachweis verbindet. Eine Lieferung kann teilweise oder unter Vorbehalt erfolgen und bedeutet nicht automatisch endgültige Abnahme, korrekte Rechnungsstellung oder Zahlung.'
      },
      EN: {
        term: 'Delivery',
        shortDefinition: 'A traceable handover of a product or result to an identified recipient.',
        detailedDefinition: 'An event linking the order, handed-over quantities, date, place, condition, transport, recipient and evidence. A delivery may be partial or subject to reservations and does not automatically mean final acceptance, correct invoicing or payment.'
      }
    }
  }
};

export const getGlossaryContextEntry = (termId, language = 'FR') => {
  const entry = GLOSSARY_CONTEXT[termId];
  if (!entry) return null;

  const normalizedLanguage = ['FR', 'DE', 'EN'].includes(language) ? language : 'FR';
  return {
    id: termId,
    version: entry.version,
    status: entry.status || 'validated',
    ...entry.translations[normalizedLanguage]
  };
};

export const GLOSSARY_CONTEXT_IDS = Object.freeze(Object.keys(GLOSSARY_CONTEXT));
